/*
 * eb-webinar-live.js — sala del directo del 11-nov (/pages/webinar-directo, Task 6) y grabación
 * (/pages/webinar-grabacion, Task 7: la sección la pone T7; la lógica está aquí, ver 3).
 * Contratos del plan 2026-10-17-webinar-28oct: C1 (config), C2 (core), C3 (protocolo del Worker
 * ebw-live), C4 (eventos de Klaviyo, eb-webinar-form.js) y C5 (auto-montaje: [data-ebw-room] →
 * sala · [data-ebw-replay] → grabación).
 *
 * Tres partes:
 *  1. Lógica pura (tests en tests/webinar/live.test.mjs): reduce, backoff, stableDropDelay,
 *     clockOffset, shouldSendAttendance, accumulateLive, effectiveState/effectivePhase,
 *     codeVisible/codeAction, embedUrl/watchUrl, wsUrl, salaFrom, makeCid, parseMessage,
 *     splitLines, withoutKx, codigoProps, decodeB64Utf8, replayView/parseStart/formatClock/
 *     replayShouldSend, createAnnouncer (avisos del mismo tic en uno), createEvents (eventos de
 *     Klaviyo con reintento y tiempo límite), watchIdentity (klaviyo.js con tiempo límite) y
 *     stateUrl y createLink (WebSocket con reconexión, ping y reloj, y respaldo por HTTP; sin DOM,
 *     todo inyectable).
 *  2. Sala ([data-ebw-room]) que se monta sola en EBW.onReady:
 *     - Estado efectivo = el forzado por el Worker o, si no, EBW.roomState por hora. Se escribe en la
 *       raíz: data-room-state (before|doors|live|ended) y data-room-view (lo mismo + "cerrado"
 *       desde replayUntil). El CSS enseña [data-ebw-room-view~="<vista>"].
 *     - Vídeo detrás de un póster "Entrar con sonido" (YouTube sin cookies o Cloudflare Stream);
 *       el Worker puede cambiarlo en caliente.
 *     - Chat (nombre en localStorage.ebw_name, cid en localStorage.ebw_cid), contador real,
 *       aviso fijado, programa por hora o fase forzada, guinda censurada hasta revelado.on (el
 *       título llega solo del Worker), código hasta config.codeUntil.
 *     - Klaviyo (EBW.klaviyo de eb-webinar-form.js): 'asistencia' tras 10 min en live con la
 *       persona identificada (_kx de la URL → sessionStorage.ebw_kx y se quita de la barra, o
 *       klaviyo.js, que tiene como mucho 8 s para contestar); 'codigo' con la propiedad codigo,
 *       identificada y 10 min. Sin identificar y con 10 min: mini formulario (form[data-ebw-mini],
 *       alta + Registro + Codigo); identificada, puede pedirlo "a otro email" con el mismo mini.
 *       Si el evento Codigo falla (bloqueador que corta a.klaviyo.com, red), también sale el mini
 *       con [data-ebw-code-failed]; si el mini falla, su error enlaza contact@.
 *       Nada con ?ebw_now= ni en la sala de prueba.
 *     - Al revelarse el código en directo, una pastilla bajo el vídeo lleva hasta el sobre.
 *     - En la vista "cerrado" no se conecta con el Worker.
 *     - Sin Worker (o caído): el vídeo sigue, el programa va por hora, el chat dice "no disponible"
 *       y reconecta con espera creciente (1 s, 2 s, 4 s… hasta 30 s). Si se cae una conexión que
 *       iba bien (el Durable Object se reinicia y caen todas a la vez), el primer reintento se
 *       reparte entre 0,5 y 5 s para no volver todas en el mismo segundo. Desde la hora de la
 *       guinda, sin datos del Worker, sale el aviso honesto de respaldo del tema.
 *     - Red que bloquea los WebSockets (proxy, antivirus) pero no HTTP: tras 3 intentos seguidos
 *       que no llegan a abrirse, se sondea GET <live.http>/state cada 30-60 s (estado y fase
 *       forzados, guinda, código y hora del servidor por x-ebw-server-now). El chat sigue "no
 *       disponible". El sondeo se para en cuanto el WebSocket vuelve a abrirse.
 *     - El aviso honesto de respaldo del tema llega en base64 (data-ebw-b64): no se lee en el
 *       código fuente antes del revelado.
 *     ?ebw_sala=prueba usa la sala de ensayo del Worker.
 *  3. Grabación ([data-ebw-replay], mountReplay). Contrato del marcado (lo pinta
 *     sections/eb-webinar-grabacion.liquid; tests en tests/webinar/replay.test.mjs):
 *       raíz [data-ebw-replay] (clases recomendadas "ebw ebw--carbon ebw-room ebw-replay"). Si
 *         Shopify pinta la página ya caducada, la sección sale cerrada sin este atributo (no se monta).
 *         data-video-provider="youtube|cloudflare" · data-video-id · data-cf-customer (opcional)
 *         data-video-start="<s>" (opcional; si no, el segundo del primer capítulo)
 *         → el JS pone data-replay-view="espera|grabacion|cerrado": espera sin vídeo; cerrado desde
 *           config.replayUntil (se quita el iframe, también si se está viendo a esa hora). Si la
 *           raíz llega con data-replay-view="grabacion" (lo pinta el servidor con algo en el id),
 *           se respeta aunque data-video-id no valga (VIDEO_ID_RE): sin play, sin enlace al vídeo y
 *           con [data-ebw-video-missing]; nunca se pasa a la espera, que no está en ese HTML.
 *       [data-ebw-replay-view~="espera|grabacion|cerrado"]  piezas por vista (las oculta el CSS)
 *       [data-ebw-player] > [data-ebw-poster] > [data-ebw-play]  como en la sala. Sin
 *         [data-ebw-play], el iframe se pone al cargar (sin autoplay).
 *       [data-ebw-video-link]  enlace de respaldo a YouTube (el JS le añade &t=<s>)
 *       [data-ebw-video-missing]  aviso "el vídeo no se ha podido cargar" (opcional): visible solo
 *         en la grabación sin un id que valga
 *       Capítulo que es enlace + Cmd/Ctrl/Mayús/Alt: el navegador lo abre donde se le pide.
 *       [data-ebw-chapter][data-start="<s>"]  <a href> o <button>: recarga el iframe desde ese
 *         segundo (start=); el último pulsado lleva aria-current="true". [data-ebw-chapter-time]
 *         vacío dentro → el JS escribe m:ss / h:mm:ss.
 *       [data-ebw-replay-live]  región aria-live="polite" (opcional)
 *       [data-ebw-replay-focus][tabindex="-1"]  título del cierre: recibe el foco si caduca con el
 *         foco en el vídeo (opcional)
 *       script[type="application/json"][data-ebw-replay-text]  textos (opcional): video_titulo,
 *         capitulo_anuncio, cerrado_anuncio.
 *     Evento 'grabacion' (uid wb1028-grabacion) con _kx o klaviyo.js, al primer clic que arranca
 *     el vídeo (póster o capítulo) o a los 60 s con el iframe a la vista. Nada con ?ebw_now=.
 *
 * Todo lo que llega del Worker se pinta con textContent. ES2019, sin dependencias.
 * Necesita eb-webinar-core.js (layout, defer) y eb-webinar-form.js (sección, defer, antes que este).
 */
(function (root, factory) {
  var api = factory(root);
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root && root.document) {
    root.EBW = root.EBW || {};
    root.EBW.live = Object.assign(root.EBW.live || {}, api);
    api._boot();
  }
})(typeof window !== 'undefined' ? window : globalThis, function (root) {
  'use strict';

  var MIN = 60000;
  var ATTEND_MS = 10 * MIN; // asistencia y código: 10 min en directo
  var PING_MS = 25000;
  var DEAD_MS = 65000; // sin nada del servidor (ni "pong") en este tiempo: conexión muerta
  var STABLE_MS = 10000; // una conexión que dura menos no reinicia la espera
  var GRACE_MS = 45000; // lo forzado por el Worker aguanta este tiempo tras una caída
  var HTTP_AFTER_FAILS = 3; // el WebSocket no llega a abrirse 3 veces seguidas: respaldo por HTTP
  var POLL_MIN_MS = 30000; // GET /state cada 30-60 s (al azar) mientras no haya WebSocket
  var POLL_MAX_MS = 60000;
  var HTTP_TIMEOUT_MS = 10000;
  var HTTP_FRESH_MS = POLL_MAX_MS + GRACE_MS; // lo que trae /state vale hasta el siguiente sondeo (+ margen)
  var BACKOFF_BASE = 1000;
  var BACKOFF_MAX = 30000;
  var JITTER = 0.2;
  var BANNED_MIN_ATTEMPT = 3; // silenciada: la primera vuelta, a los ~8 s
  var MSG_MAX = 200;
  var TICK_CAP_MS = 70000;
  var OFFSET_MIN_MS = 1500; // por debajo, el reloj del dispositivo vale
  var EVENT_RETRY_MS = 60000;
  var EVENT_TRIES = 3;
  var EVENT_TIMEOUT_MS = 10000; // un evento que no contesta en este tiempo cuenta como fallo
  var SPREAD_MIN_MS = 500; // primer reintento tras perder una conexión estable: entre esto...
  var SPREAD_MAX_MS = 5000; // ...y esto, al azar (todas las conexiones caen a la vez)
  var REPLAY_VIEW_MS = 60000; // grabación: 60 s con el vídeo a la vista = vista
  var START_MAX_S = 6 * 3600;
  var ANNOUNCE_MS = 60;
  var IDENT_BUDGET_MS = 8000; // klaviyo.js: como mucho esto para saber si conoce a la persona
  var IDENT_WAIT_MS = 5000; // ...y esto para que conteste isIdentified() (dentro del presupuesto)
  var IDENT_STEP_MS = 500;
  var ESTADOS = ['before', 'doors', 'live', 'ended'];
  var CHAT_MODES = ['abierto', 'lento', 'cerrado'];
  var LINKS = ['idle', 'connecting', 'open', 'down', 'off'];
  var VIDEO_ID_RE = /^[A-Za-z0-9_-]{1,64}$/;
  var CID_RE = /^[A-Za-z0-9_-]{6,64}$/;
  var CHAT_ERRORS = {
    rate: 'chat_err_rate',
    closed: 'chat_err_closed',
    len: 'chat_err_len',
    link: 'chat_err_link',
    banned: 'chat_err_banned',
    name: 'chat_err_name',
    filtro: 'chat_err_filtro',
  };

  function warn(where, err) {
    if (root.document && root.console && root.console.warn) root.console.warn('[EBW live] ' + where, err === undefined ? '' : err);
  }

  function isObj(o) {
    return !!o && typeof o === 'object' && !Array.isArray(o);
  }

  function str(v, max) {
    return typeof v === 'string' ? v.slice(0, max || 500) : '';
  }

  function num(v) {
    var n = Number(v);
    return isFinite(n) ? n : 0;
  }

  function assign(base, patch) {
    return Object.assign({}, base, patch);
  }

  function clamp01(x) {
    return x < 0 ? 0 : x > 1 ? 1 : x;
  }

  /* ------------------------------------------------------------------ */
  /* Lógica pura                                                         */
  /* ------------------------------------------------------------------ */

  // Espera antes del reintento n (0 = el primero): 1 s, 2 s, 4 s… hasta 30 s, ±20 %.
  function backoff(attempt, rnd) {
    var n = Math.floor(Number(attempt));
    if (!isFinite(n) || n < 0) n = 0;
    var base = Math.min(BACKOFF_MAX, BACKOFF_BASE * Math.pow(2, Math.min(n, 16)));
    var r = typeof rnd === 'number' && rnd >= 0 && rnd < 1 ? rnd : Math.random();
    return Math.round(base * (1 - JITTER + 2 * JITTER * r));
  }

  // Primer reintento tras perder una conexión que iba bien. Si el Durable Object se reinicia, caen
  // todas a la vez: con ±20 % sobre 1 s volverían ~1.500 en 0,4 s (límite blando ~1.000 peticiones/s
  // por objeto, spec §5.4). Repartidas entre 0,5 y 5 s salen ~330/s.
  function stableDropDelay(rnd) {
    var r = typeof rnd === 'number' && rnd >= 0 && rnd < 1 ? rnd : Math.random();
    return Math.round(SPREAD_MIN_MS + r * (SPREAD_MAX_MS - SPREAD_MIN_MS));
  }

  // Desfase del reloj del dispositivo: hora del servidor menos el punto medio del viaje.
  function clockOffset(serverNow, t0, t1) {
    var s = Number(serverNow);
    var a = Number(t0);
    var b = Number(t1);
    if (!isFinite(s) || !isFinite(a) || !isFinite(b) || b < a) return 0;
    return Math.round(s - (a + b) / 2);
  }

  function shouldSendAttendance(o) {
    return !!(o && o.identified === true) && num(o.liveMs) >= ATTEND_MS;
  }

  // Tiempo en directo: suma lo transcurrido entre dos tics solo en live, con tope por salto.
  function accumulateLive(prevMs, lastT, t, state) {
    var base = Math.max(0, num(prevMs));
    var a = Number(lastT);
    var b = Number(t);
    if (state !== 'live' || !isFinite(a) || !isFinite(b) || b <= a) return base;
    return base + Math.min(b - a, TICK_CAP_MS);
  }

  function initialModel() {
    return { server: null, serverNow: null, msgs: [], count: null, err: null, link: 'idle', lostAt: null, httpAt: null, banned: false };
  }

  function cleanMsg(m) {
    if (!isObj(m) || typeof m.id !== 'string' || !m.id) return null;
    return { id: m.id.slice(0, 40), name: str(m.name, 60), text: str(m.text, 600), ts: num(m.ts), team: m.team === true };
  }

  function cleanVideo(v) {
    if (!isObj(v) || (v.proveedor !== 'youtube' && v.proveedor !== 'cloudflare')) return null;
    return typeof v.id === 'string' && VIDEO_ID_RE.test(v.id) ? { proveedor: v.proveedor, id: v.id } : null;
  }

  // PublicState (C3) con tipos fijos. titulo/texto/valor solo si están "on" y con contenido.
  function cleanServer(s) {
    if (!isObj(s)) return null;
    var r = isObj(s.revelado) ? s.revelado : {};
    var c = isObj(s.codigo) ? s.codigo : {};
    var k = isObj(s.contador) ? s.contador : {};
    var aviso = typeof s.aviso === 'string' ? s.aviso.trim().slice(0, 600) : '';
    return {
      estado: ESTADOS.indexOf(s.estado) !== -1 ? s.estado : null,
      fase: typeof s.fase === 'number' && s.fase >= 0 && Math.floor(s.fase) === s.fase ? s.fase : null,
      chat: CHAT_MODES.indexOf(s.chat) !== -1 ? s.chat : 'abierto',
      contador: { on: k.on === true, min: Math.max(0, Math.floor(num(k.min))) },
      video: cleanVideo(s.video),
      aviso: aviso || null,
      revelado:
        r.on === true && typeof r.titulo === 'string' && r.titulo.trim()
          ? { on: true, titulo: r.titulo.trim().slice(0, 200), texto: str(r.texto, 2000) }
          : { on: false },
      codigo:
        c.on === true && typeof c.valor === 'string' && c.valor.trim()
          ? { on: true, valor: c.valor.trim().slice(0, 80) }
          : { on: false },
    };
  }

  // Modelo de la sala a partir de los mensajes del Worker (C3) y de la conexión.
  //   {t:'state'|'hist'|'msg'|'del'|'count'|'err'} del servidor
  //   createLink añade first:true al primer state de cada conexión, y genera {t:'state', via:'http',
  //   at} (respaldo GET /state), {t:'link', link, at} y {t:'banned'} (cierre 4003)
  function reduce(state, msg) {
    var s = state || initialModel();
    if (!isObj(msg)) return s;
    switch (msg.t) {
      case 'state': {
        var srv = cleanServer(msg.s);
        if (!srv) return s;
        var sn = Number(msg.serverNow);
        var patch = { server: srv, serverNow: isFinite(sn) && sn > 0 ? sn : s.serverNow };
        if (msg.via === 'http') patch.httpAt = num(msg.at);
        // Silenciada (cierre 4003 o err 'banned'): se vuelve a poder escribir al reconectar, con el
        // primer estado de la nueva conexión. Si sigue silenciada, el servidor contesta otra vez
        // {t:'err',code:'banned'} al enviar y el formulario se vuelve a ocultar.
        else if (msg.first === true) patch.banned = false;
        return assign(s, patch);
      }
      case 'hist': {
        if (!Array.isArray(msg.msgs)) return s;
        var hp = { msgs: msg.msgs.map(cleanMsg).filter(Boolean).slice(-MSG_MAX) };
        // Historial vacío = sala reiniciada desde el panel (borra también los silencios).
        if (!hp.msgs.length) hp.banned = false;
        return assign(s, hp);
      }
      case 'msg': {
        var m = cleanMsg(msg.m);
        if (!m) return s;
        for (var i = s.msgs.length - 1; i >= 0; i--) if (s.msgs[i].id === m.id) return s;
        var next = s.msgs.concat([m]);
        return assign(s, { msgs: next.length > MSG_MAX ? next.slice(-MSG_MAX) : next });
      }
      case 'del': {
        if (typeof msg.id !== 'string') return s;
        var kept = s.msgs.filter(function (x) {
          return x.id !== msg.id;
        });
        return kept.length === s.msgs.length ? s : assign(s, { msgs: kept });
      }
      case 'count': {
        var n = msg.n;
        return assign(s, { count: typeof n === 'number' && isFinite(n) && n >= 0 ? Math.floor(n) : null });
      }
      case 'err': {
        var ep = { err: { code: str(msg.code, 20), retryMs: Math.max(0, num(msg.retryMs)) } };
        // Silenciada: el formulario se oculta hasta la próxima conexión (cada envío sería una
        // petición más al Durable Object).
        if (ep.err.code === 'banned') ep.banned = true;
        return assign(s, ep);
      }
      case 'link': {
        if (LINKS.indexOf(msg.link) === -1) return s;
        var lp = { link: msg.link };
        if (msg.link === 'open') {
          lp.lostAt = null;
          lp.httpAt = null; // con el WebSocket abierto, lo del sondeo HTTP sobra
        } else {
          lp.count = null; // sin conexión no hay número real que enseñar
          if (s.link === 'open') lp.lostAt = num(msg.at);
        }
        return assign(s, lp);
      }
      case 'banned':
        return assign(s, { banned: true });
      default:
        return s;
    }
  }

  // Lo forzado por el Worker vale con la conexión abierta, hasta GRACE_MS después de perderla y,
  // sin WebSocket, hasta HTTP_FRESH_MS después del último GET /state que ha contestado.
  function forcedValid(model, realNow) {
    if (!model || !model.server) return false;
    if (model.link === 'open') return true;
    var now = num(realNow);
    if (model.httpAt !== null && model.httpAt !== undefined && now - model.httpAt < HTTP_FRESH_MS) return true;
    return model.lostAt !== null && model.lostAt !== undefined && now - model.lostAt < GRACE_MS;
  }

  function effectiveState(model, local, realNow) {
    if (forcedValid(model, realNow) && model.server.estado) return model.server.estado;
    return local;
  }

  function effectivePhase(model, localIndex, count, realNow) {
    if (forcedValid(model, realNow)) {
      var f = model.server.fase;
      if (f !== null && f >= 0 && f < count) return f;
    }
    return localIndex;
  }

  function codeVisible(model, t, codeUntil) {
    var c = model && model.server && model.server.codigo;
    if (!c || !c.on) return false;
    var until = Number(codeUntil);
    return !isFinite(until) || t < until;
  }

  // Qué hacer con el código visible: 'none' (solo verlo) | 'wait' (aún no se sabe si está
  // identificada) | 'event' | 'mini' | 'sent'. qa: ?ebw_now= o sala de prueba (no se manda nada;
  // el mini se ve, pero su envío se bloquea). failed: el evento Codigo ha fallado (bloqueador,
  // red): sale el mini para que deje su email (y si también falla, su error enlaza contact@).
  function codeAction(o) {
    var p = o || {};
    if (!p.visible || num(p.liveMs) < ATTEND_MS) return 'none';
    if (p.sent) return 'sent';
    if (p.identified === null || p.identified === undefined) return 'wait';
    if (!p.identified || p.failed) return 'mini';
    return p.qa ? 'none' : 'event';
  }

  // Aviso honesto (filosofía §9.4, spec §6.2): con la guinda revelada por el Worker o tras el
  // directo. Sin datos del Worker (caído o inalcanzable: forced = false), en directo desde la hora
  // de la fase secreta: el de respaldo del tema. Nunca en "cerrado".
  // o = {view, revealed, forced, t, secretStartMs}
  function honestVisible(o) {
    var p = o || {};
    if (p.view === 'cerrado') return false;
    if (p.revealed === true || p.view === 'ended') return true;
    var at = Number(p.secretStartMs);
    if (p.view !== 'live' || p.forced || p.secretStartMs === null || !isFinite(at)) return false;
    return num(p.t) >= at;
  }

  // ¿Se anuncia el cambio de fase? No la primera pasada (por hora) ni la hidratación (primer
  // estado del Worker: entrar tarde con la fase forzada no es un cambio), ni fuera del programa.
  function phaseShouldAnnounce(prev, idx, count, hydrating) {
    if (prev === undefined || hydrating || idx === prev) return false;
    return typeof idx === 'number' && idx >= 0 && idx < count;
  }

  // Segundo de arranque (start=): entero, de 0 a 6 h. Cualquier otra cosa → 0.
  function parseStart(v) {
    var n = typeof v === 'string' && /^\s*\d+\s*$/.test(v) ? Number(v) : typeof v === 'number' ? v : NaN;
    if (!isFinite(n) || n < 0) return 0;
    return Math.min(START_MAX_S, Math.floor(n));
  }

  // opts = {autoplay, start (segundos), customer (Cloudflare)}
  function embedUrl(video, opts) {
    var v = cleanVideo(video);
    if (!v) return '';
    var o = opts || {};
    var start = parseStart(o.start);
    if (v.proveedor === 'cloudflare') {
      var customer = typeof o.customer === 'string' && /^[a-z0-9]{1,64}$/i.test(o.customer) ? o.customer : '';
      var base = customer
        ? 'https://customer-' + customer + '.cloudflarestream.com/' + v.id + '/iframe'
        : 'https://iframe.videodelivery.net/' + v.id;
      var q = [];
      if (o.autoplay) q.push('autoplay=true');
      if (start) q.push('startTime=' + start);
      return base + (q.length ? '?' + q.join('&') : '');
    }
    return (
      'https://www.youtube-nocookie.com/embed/' + v.id + '?playsinline=1&rel=0' +
      (o.autoplay ? '&autoplay=1' : '') +
      (start ? '&start=' + start : '')
    );
  }

  function watchUrl(video, start) {
    var v = cleanVideo(video);
    if (!v || v.proveedor !== 'youtube') return '';
    var s = parseStart(start);
    return 'https://www.youtube.com/watch?v=' + v.id + (s ? '&t=' + s + 's' : '');
  }

  // 754 → "12:34"; 4500 → "1:15:00".
  function formatClock(seconds) {
    var s = parseStart(seconds);
    var h = Math.floor(s / 3600);
    var m = Math.floor((s % 3600) / 60);
    var r = s % 60;
    var mm = h ? (m < 10 ? '0' : '') + m : String(m);
    return (h ? h + ':' : '') + mm + ':' + (r < 10 ? '0' : '') + r;
  }

  // Grabación: 'cerrado' desde replayUntil (aunque haya vídeo); si no, 'grabacion' (publicada: hay
  // vídeo, o el servidor ya ha pintado la grabación) o 'espera'.
  function replayView(t, replayUntil, published) {
    var until = Number(replayUntil);
    if (isFinite(until) && Number(t) >= until) return 'cerrado';
    return published ? 'grabacion' : 'espera';
  }

  // "Grabacion vista": identificada y (primer clic que arranca el vídeo o 60 s con él a la vista).
  function replayShouldSend(o) {
    var p = o || {};
    if (p.qa || p.sent || p.identified !== true) return false;
    return p.clicked === true || num(p.visibleMs) >= REPLAY_VIEW_MS;
  }

  // base64 (UTF-8) → texto. Vacío si no se puede.
  function decodeB64Utf8(b64) {
    if (typeof b64 !== 'string' || !b64) return '';
    try {
      var bin = (root.atob || atob)(b64.replace(/\s+/g, ''));
      if (typeof TextDecoder === 'function') {
        var bytes = new Uint8Array(bin.length);
        for (var i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
        return new TextDecoder('utf-8').decode(bytes);
      }
      return decodeURIComponent(escape(bin));
    } catch (e) {
      return '';
    }
  }

  // Avisos para lectores de pantalla: los del mismo tic salen juntos y en orden (uno no pisa al
  // otro). o = {write(text), setTimeout, delay}
  function createAnnouncer(o) {
    var opts = o || {};
    var later = opts.setTimeout || setTimeout;
    var delay = typeof opts.delay === 'number' ? opts.delay : ANNOUNCE_MS;
    var queue = [];
    var timer = null;
    return function announce(text) {
      var clean = String(text == null ? '' : text).replace(/\s+/g, ' ').trim();
      if (!clean) return;
      var item = /[.!?…:]$/.test(clean) ? clean : clean + '.';
      if (queue.indexOf(item) !== -1) return;
      queue.push(item);
      if (timer !== null) return;
      // Se vacía y, un instante después, se escribe: algunos lectores no repiten un texto idéntico.
      opts.write('');
      timer = later(function () {
        timer = null;
        var msg = queue.join(' ');
        queue = [];
        opts.write(msg);
      }, delay);
    };
  }

  // Eventos de Klaviyo con reintento: como mucho EVENT_TRIES intentos (uno por minuto), uno a la
  // vez y con tiempo límite (klaviyo.track o fetch que no contestan cuentan como fallo).
  // o = {send(key, props) → Promise<{ok, reason}>, load() → {key:true}, save(map), now, setTimeout,
  //      clearTimeout, onDone(key, ok, result)}
  function createEvents(o) {
    var opts = o || {};
    var clock = opts.now || Date.now;
    var later = opts.setTimeout || setTimeout;
    var cancel = opts.clearTimeout || clearTimeout;
    var tries = {};
    var nextTry = {};
    var pending = {};
    var failed = {};

    function loadSent() {
      try {
        var m = opts.load ? opts.load() : null;
        return isObj(m) ? m : {};
      } catch (e) {
        return {};
      }
    }
    var sent = loadSent();

    function mark(key) {
      // Se relee antes de guardar: otra pestaña (sala o grabación) puede haber marcado otra clave.
      sent = Object.assign(loadSent(), sent);
      sent[key] = true;
      failed[key] = false;
      if (opts.save) {
        try {
          opts.save(sent);
        } catch (e) {
          /* almacenamiento bloqueado: vale para esta página */
        }
      }
    }

    function finish(key, r) {
      pending[key] = false;
      var ok = !!(r && r.ok);
      if (ok) mark(key);
      else if (!(r && r.reason === 'qa')) {
        failed[key] = true;
        nextTry[key] = clock() + EVENT_RETRY_MS;
      }
      if (typeof opts.onDone === 'function') {
        try {
          opts.onDone(key, ok, r || {});
        } catch (e) {
          warn('evento ' + key, e);
        }
      }
    }

    return {
      sent: function (key) {
        return !!sent[key];
      },
      failed: function (key) {
        return !!failed[key] && !sent[key];
      },
      exhausted: function (key) {
        return !sent[key] && (tries[key] || 0) >= EVENT_TRIES && !pending[key];
      },
      mark: mark,
      // false si no toca (ya enviado, en curso, sin intentos o esperando al siguiente minuto).
      trySend: function (key, props) {
        if (sent[key] || pending[key] || (tries[key] || 0) >= EVENT_TRIES || clock() < (nextTry[key] || 0)) return false;
        pending[key] = true;
        tries[key] = (tries[key] || 0) + 1;
        var settled = false;
        var timer = later(function () {
          if (settled) return;
          settled = true;
          finish(key, { ok: false, reason: 'timeout' });
        }, EVENT_TIMEOUT_MS);
        var p;
        try {
          p = Promise.resolve(opts.send(key, props));
        } catch (e) {
          p = Promise.resolve({ ok: false });
        }
        p.then(
          function (r) {
            if (settled) return;
            settled = true;
            cancel(timer);
            finish(key, r);
          },
          function () {
            if (settled) return;
            settled = true;
            cancel(timer);
            finish(key, { ok: false });
          }
        );
        return true;
      },
    };
  }

  function wsUrl(base, cid, sala) {
    if (typeof base !== 'string' || !/^wss?:\/\//i.test(base)) return '';
    var url = base + (base.indexOf('?') === -1 ? '?' : '&') + 'cid=' + encodeURIComponent(cid || '');
    if (sala && sala !== 'principal') url += '&sala=' + encodeURIComponent(sala);
    return url;
  }

  // GET /state del Worker (respaldo por HTTP): <live.http>/state[?sala=prueba].
  function stateUrl(base, sala) {
    if (typeof base !== 'string' || !/^https?:\/\/[^\s]+$/i.test(base)) return '';
    var b = base.replace(/[?#].*$/, '').replace(/\/+$/, '');
    return b + '/state' + (sala && sala !== 'principal' ? '?sala=' + encodeURIComponent(sala) : '');
  }

  // Solo la sala de ensayo se elige por URL: la principal es la de por defecto.
  function salaFrom(search) {
    return /(?:^|[?&])ebw_sala=prueba(?:&|#|$)/.test(String(search || '')) ? 'prueba' : '';
  }

  var CID_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_-';

  function makeCid() {
    var bytes = [];
    var i;
    try {
      var c = root.crypto;
      if (c && typeof c.getRandomValues === 'function') bytes = Array.prototype.slice.call(c.getRandomValues(new Uint8Array(20)));
    } catch (e) {
      bytes = [];
    }
    for (i = bytes.length; i < 20; i++) bytes.push(Math.floor(Math.random() * 256));
    var out = 'w';
    for (i = 0; i < bytes.length; i++) out += CID_CHARS.charAt(bytes[i] % 64);
    return out;
  }

  function parseMessage(data) {
    if (typeof data !== 'string' || data === 'pong' || data.length > 1048576) return null;
    try {
      var obj = JSON.parse(data);
      return isObj(obj) && typeof obj.t === 'string' ? obj : null;
    } catch (e) {
      return null;
    }
  }

  function splitLines(text) {
    return String(text == null ? '' : text)
      .split(/\r?\n/)
      .map(function (l) {
        return l.trim();
      })
      .filter(Boolean);
  }

  // Query string sin _kx: un enlace de la sala reenviado (WhatsApp) no identifica a otra persona.
  function withoutKx(search) {
    var s = String(search || '').replace(/^\?/, '');
    var kept = s.split('&').filter(function (part) {
      return part && !/^_kx(?:=|$)/.test(part);
    });
    return kept.length ? '?' + kept.join('&') : '';
  }

  // Propiedades del evento Codigo del mini formulario: minutos se lee al enviar (getter enumerable,
  // que eb-webinar-form.js copia con Object.keys), no cuando aparece el código.
  function codigoProps(valor, getLiveMs) {
    return {
      codigo: valor,
      get minutos() {
        return Math.floor(Math.max(0, num(getLiveMs())) / MIN);
      },
    };
  }

  // ¿klaviyo.js conoce a la persona? cb(yes, late). Nunca se queda esperando:
  //  - busca window.klaviyo cada 500 ms hasta 8 s;
  //  - isIdentified() tiene 5 s (y nunca más allá de los 8 s) para contestar. El snippet oficial
  //    (cola + Proxy) devuelve una promesa que solo se resuelve si carga klaviyo.js: con bloqueador,
  //    cookies rechazadas o la CDN caída no llega nunca → cb(false).
  //  - si después contesta que sí (klaviyo.js lento), cb(true, true) una vez.
  // o = {getKlaviyo, setTimeout, clearTimeout} (inyectables para los tests).
  function watchIdentity(o, cb) {
    var opts = o || {};
    var later = opts.setTimeout || setTimeout;
    var cancel = opts.clearTimeout || clearTimeout;
    var getK =
      opts.getKlaviyo ||
      function () {
        return root.klaviyo;
      };
    var waited = 0;
    var result = null; // null = sin contestar · true · false
    var lateSent = false;
    var raceTimer = null;

    function report(yes, late) {
      try {
        cb(yes, late);
      } catch (e) {
        warn('identidad', e);
      }
    }

    function finish(yes) {
      if (result !== null) return;
      result = yes;
      if (raceTimer !== null) cancel(raceTimer);
      raceTimer = null;
      report(yes, false);
    }

    function answered(yes) {
      if (result === null) finish(yes === true);
      else if (result === false && yes === true && !lateSent) {
        lateSent = true;
        report(true, true);
      }
    }

    (function poll() {
      if (result !== null) return;
      var k = null;
      try {
        k = getK();
      } catch (e) {
        k = null;
      }
      if (k && typeof k.isIdentified === 'function') {
        raceTimer = later(function () {
          raceTimer = null;
          finish(false);
        }, Math.max(0, Math.min(IDENT_WAIT_MS, IDENT_BUDGET_MS - waited)));
        var p;
        try {
          p = k.isIdentified();
        } catch (e) {
          finish(false);
          return;
        }
        Promise.resolve(p).then(answered, function () {
          finish(false);
        });
        return;
      }
      if (waited >= IDENT_BUDGET_MS) {
        finish(false);
        return;
      }
      waited += IDENT_STEP_MS;
      later(poll, IDENT_STEP_MS);
    })();
  }

  /* ------------------------------------------------------------------ */
  /* Conexión con el Worker (sin DOM; todo inyectable para los tests)     */
  /* ------------------------------------------------------------------ */

  // o = {url, WebSocket, setTimeout, clearTimeout, setInterval, clearInterval, clock, random,
  //      onModel(model, msg), onClock(offsetMs), onOpen(),
  //      httpUrl, fetch, AbortController (respaldo GET /state si el WebSocket no llega a abrirse)}
  function createLink(o) {
    var opts = o || {};
    var clock = opts.clock || Date.now;
    var later = opts.setTimeout || setTimeout;
    var cancel = opts.clearTimeout || clearTimeout;
    var every = opts.setInterval || setInterval;
    var stopEvery = opts.clearInterval || clearInterval;
    var random = opts.random || Math.random;
    var model = initialModel();
    var ws = null;
    var attempt = 0;
    var retryTimer = null;
    var pingTimer = null;
    var lastSeen = 0;
    var openedAt = 0;
    var startedAt = 0;
    var firstState = true;
    var stopped = false;
    var banned = false;
    var fails = 0; // intentos seguidos que no llegan a abrirse (red que bloquea los WebSockets)
    var polling = false;
    var pollTimer = null;
    var pollGen = 0;

    function emit(msg) {
      var next = reduce(model, msg);
      if (next === model) return;
      model = next;
      if (typeof opts.onModel === 'function') {
        try {
          opts.onModel(model, msg);
        } catch (e) {
          warn('onModel', e);
        }
      }
    }

    function stopPing() {
      if (pingTimer !== null) stopEvery(pingTimer);
      pingTimer = null;
    }

    function detach(sock) {
      if (!sock) return;
      sock.onopen = sock.onmessage = sock.onclose = sock.onerror = null;
    }

    // ---- respaldo por HTTP: GET /state cada 30-60 s mientras el WebSocket no abre ----
    function canPoll() {
      return typeof opts.httpUrl === 'string' && !!opts.httpUrl && typeof opts.fetch === 'function';
    }

    function stopPoll() {
      polling = false;
      pollGen++;
      if (pollTimer !== null) cancel(pollTimer);
      pollTimer = null;
    }

    function startPoll() {
      if (polling || stopped || !canPoll()) return;
      polling = true;
      pollGen++;
      pollOnce();
    }

    function pollOnce() {
      if (!polling || stopped) return;
      var gen = pollGen;
      var settled = false;
      var t0 = clock();
      var ctrl = null;
      try {
        var Abort = opts.AbortController || (typeof AbortController === 'function' ? AbortController : null);
        if (Abort) ctrl = new Abort();
      } catch (e) {
        ctrl = null;
      }
      function next() {
        if (gen !== pollGen || !polling || stopped) return;
        if (pollTimer !== null) cancel(pollTimer);
        pollTimer = later(function () {
          pollTimer = null;
          pollOnce();
        }, Math.round(POLL_MIN_MS + random() * (POLL_MAX_MS - POLL_MIN_MS)));
      }
      var guard = later(function () {
        if (settled) return;
        settled = true;
        try {
          if (ctrl) ctrl.abort();
        } catch (e) {
          /* ya terminada */
        }
        next();
      }, HTTP_TIMEOUT_MS);
      var p;
      try {
        var init = { cache: 'no-store', credentials: 'omit' };
        if (ctrl) init.signal = ctrl.signal;
        p = Promise.resolve(opts.fetch(opts.httpUrl, init));
      } catch (e) {
        p = Promise.reject(e);
      }
      p.then(function (res) {
        if (!res || !res.ok) throw new Error('GET /state ' + (res ? res.status : ''));
        var h = res.headers && typeof res.headers.get === 'function' ? res.headers.get('x-ebw-server-now') : null;
        return Promise.resolve(res.json()).then(function (body) {
          return { body: body, serverNow: h === null || h === '' ? NaN : Number(h) };
        });
      }).then(
        function (r) {
          if (settled) return;
          settled = true;
          cancel(guard);
          // El WebSocket ha vuelto mientras tanto (o se ha parado): lo suyo es más reciente.
          if (gen !== pollGen || !polling || stopped) return;
          var t1 = clock();
          var sn = isFinite(r.serverNow) && r.serverNow > 0 ? r.serverNow : null;
          emit({ t: 'state', s: r.body, serverNow: sn, via: 'http', at: t1 });
          if (sn !== null && typeof opts.onClock === 'function') opts.onClock(clockOffset(sn, t0, t1));
          next();
        },
        function () {
          if (settled) return;
          settled = true;
          cancel(guard);
          next();
        }
      );
    }

    function scheduleRetry(ms) {
      if (stopped) return;
      if (retryTimer !== null) cancel(retryTimer);
      retryTimer = later(function () {
        retryTimer = null;
        connect();
      }, ms);
    }

    function onClosed(code) {
      stopPing();
      ws = null;
      if (openedAt) fails = 0;
      else fails++;
      if (code === 4003) {
        banned = true;
        emit({ t: 'banned' });
      }
      emit({ t: 'link', link: 'down', at: clock() });
      var wasStable = !!openedAt && clock() - openedAt >= STABLE_MS;
      if (wasStable) attempt = 0;
      openedAt = 0;
      var n = banned ? Math.max(attempt, BANNED_MIN_ATTEMPT) : attempt;
      attempt = n + 1;
      if (attempt === 1 || attempt === 3) warn('sin conexión con la sala; reintento con espera');
      // Tras una conexión estable, el primer reintento se reparte (stableDropDelay); los demás, backoff.
      scheduleRetry(wasStable && !banned ? stableDropDelay(random()) : backoff(n, random()));
      // El WebSocket no llega a abrirse (proxy o antivirus que lo bloquean): estado por HTTP.
      if (fails >= HTTP_AFTER_FAILS) startPoll();
    }

    // Cierre decidido aquí (conexión muerta, stop): no se espera al evento del navegador.
    function drop(code) {
      var sock = ws;
      detach(sock);
      try {
        if (sock) sock.close();
      } catch (e) {
        /* ya cerrado */
      }
      onClosed(code);
    }

    function connect() {
      if (stopped || ws) return;
      if (retryTimer !== null) cancel(retryTimer);
      retryTimer = null;
      emit({ t: 'link', link: 'connecting', at: clock() });
      startedAt = clock();
      firstState = true;
      var sock;
      try {
        sock = new opts.WebSocket(opts.url);
      } catch (e) {
        onClosed(0);
        return;
      }
      ws = sock;
      sock.onopen = function () {
        openedAt = lastSeen = clock();
        fails = 0;
        stopPoll();
        emit({ t: 'link', link: 'open', at: openedAt });
        stopPing();
        pingTimer = every(function () {
          if (!ws) return;
          if (clock() - lastSeen > DEAD_MS) {
            drop(4900);
            return;
          }
          try {
            ws.send('ping');
          } catch (e) {
            /* se cerrará solo */
          }
        }, PING_MS);
        if (typeof opts.onOpen === 'function') {
          try {
            opts.onOpen();
          } catch (e) {
            warn('onOpen', e);
          }
        }
      };
      sock.onmessage = function (ev) {
        lastSeen = clock();
        var msg = parseMessage(ev && ev.data);
        if (!msg) return;
        if (msg.t === 'state') {
          // Nunca vale lo que diga el mensaje: first y via los pone solo este código.
          delete msg.via;
          delete msg.at;
          msg.first = firstState;
        }
        if (msg.t === 'state' && firstState) {
          firstState = false;
          banned = false; // de vuelta tras un silencio: la espera de reconexión vuelve a la normal
          if (typeof opts.onClock === 'function') opts.onClock(clockOffset(msg.serverNow, startedAt, lastSeen));
        }
        emit(msg);
      };
      sock.onclose = function (ev) {
        detach(sock);
        if (ws !== sock) return;
        onClosed(ev && ev.code);
      };
      sock.onerror = function () {
        /* le sigue onclose */
      };
    }

    return {
      start: function () {
        stopped = false;
        if (!opts.url || typeof opts.WebSocket !== 'function') {
          emit({ t: 'link', link: 'off', at: clock() });
          // Navegador sin WebSocket (con la sala configurada): al menos, el estado por HTTP.
          if (opts.url) startPoll();
          return;
        }
        connect();
      },
      // Volver a intentarlo ya (vuelve la red, la pestaña vuelve a primer plano).
      wake: function () {
        if (stopped || ws || !opts.url || typeof opts.WebSocket !== 'function') return;
        connect();
      },
      send: function (obj) {
        if (!ws || ws.readyState !== 1) return false;
        try {
          ws.send(JSON.stringify(obj));
          return true;
        } catch (e) {
          return false;
        }
      },
      stop: function () {
        stopped = true;
        if (retryTimer !== null) cancel(retryTimer);
        retryTimer = null;
        stopPing();
        stopPoll();
        var sock = ws;
        ws = null;
        detach(sock);
        try {
          if (sock) sock.close(1000);
        } catch (e) {
          /* ya cerrado */
        }
      },
      model: function () {
        return model;
      },
      polling: function () {
        return polling;
      },
    };
  }

  /* ------------------------------------------------------------------ */
  /* DOM: la sala                                                        */
  /* ------------------------------------------------------------------ */

  var doc = root.document;

  function core() {
    return (root.EBW && typeof root.EBW.roomState === 'function' && root.EBW) || null;
  }

  function storageOf(kind) {
    try {
      return root[kind] || null;
    } catch (e) {
      return null;
    }
  }

  function sget(store, key) {
    try {
      return store ? store.getItem(key) : null;
    } catch (e) {
      return null;
    }
  }

  function sset(store, key, value) {
    try {
      if (store) store.setItem(key, value);
    } catch (e) {
      /* almacenamiento bloqueado: solo para esta página */
    }
  }

  function sdel(store, key) {
    try {
      if (store) store.removeItem(key);
    } catch (e) {
      /* idem */
    }
  }

  // _kx de la query string (mismo criterio que eb-webinar-form.js).
  function readKx(search) {
    var C = root.EBW;
    if (C && typeof C.readKx === 'function') return C.readKx(search);
    var m = /(?:^|[?&])_kx=([^&#]*)/.exec(String(search || ''));
    if (!m) return '';
    try {
      var v = decodeURIComponent(m[1]).trim();
      return v.length <= 300 && /^[A-Za-z0-9._~=+/-]+$/.test(v) ? v : '';
    } catch (e) {
      return '';
    }
  }

  function reducedMotion() {
    return !!(root.matchMedia && root.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function qs(el, sel) {
    return el.querySelector(sel);
  }

  function qsa(el, sel) {
    return Array.prototype.slice.call(el.querySelectorAll(sel));
  }

  function setText(el, text) {
    if (el && el.textContent !== text) el.textContent = text;
  }

  function show(el, on) {
    if (el && el.hidden === !!on) el.hidden = !on;
  }

  function pad2(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function fillParagraphs(box, lines) {
    while (box.firstChild) box.removeChild(box.firstChild);
    lines.forEach(function (line) {
      var p = doc.createElement('p');
      p.textContent = line;
      box.appendChild(p);
    });
  }

  function texts(el, sel) {
    var node = qs(el, sel || 'script[data-ebw-room-text]');
    try {
      var t = node ? JSON.parse(node.textContent) : {};
      return isObj(t) ? t : {};
    } catch (e) {
      warn('textos', e);
      return {};
    }
  }

  // Ya guardado: se quita _kx de la barra (si se reenvía el enlace, no identifica a otra persona).
  function stripKxFromUrl() {
    try {
      var loc = root.location;
      var h = root.history;
      if (!loc || !h || typeof h.replaceState !== 'function') return;
      var clean = withoutKx(loc.search);
      if (clean !== loc.search) h.replaceState(h.state, '', loc.pathname + clean + loc.hash);
    } catch (e) {
      /* sin history: el enlace se queda como estaba */
    }
  }

  // Identidad para Klaviyo. value: undefined = aún no se sabe · null = no identificada ·
  // {kind:'kx'|'klaviyo'|'email', profile}. _kx de la URL (→ sessionStorage.ebw_kx) o klaviyo.js
  // (watchIdentity, ≤ 8 s); el _kx se quita de la barra 1 s después (klaviyo.js también lo lee).
  // o = {search, session, onChange(), canUpgrade() → si klaviyo.js contesta tarde que sí}.
  // El _kx se lee ya; klaviyo.js, al llamar a start() (cuando la página ya está montada).
  function trackIdentity(o) {
    var kx = readKx(o.search);
    var kxInUrl = !!kx;
    if (kx) sset(o.session, 'ebw_kx', kx);
    else kx = readKx('?_kx=' + encodeURIComponent(sget(o.session, 'ebw_kx') || ''));
    var who = {
      value: kx ? { kind: 'kx', profile: { _kx: kx } } : undefined,
      identified: function () {
        return who.value === undefined ? null : !!who.value;
      },
      start: function () {
        watchIdentity({}, function (yes, late) {
          if (!late) {
            if (who.value === undefined) who.value = yes ? { kind: 'klaviyo' } : null;
            if (kxInUrl) setTimeout(stripKxFromUrl, 1000);
          } else if (who.value === null && (!o.canUpgrade || o.canUpgrade())) {
            who.value = { kind: 'klaviyo' };
          }
          if (typeof o.onChange === 'function') o.onChange();
        });
      },
    };
    return who;
  }

  // send(key, props) para createEvents: klaviyo.track si klaviyo.js la conoce; si no, la API
  // cliente (EBW.klaviyo.event de eb-webinar-form.js) con el perfil ({_kx} o {email}).
  // Pendiente de comprobar en el QA de Task 10: si klaviyo.js traduce $event_id al unique_id
  // (si no, la misma persona en dos navegadores puede dar dos eventos; filtro en el flow).
  function makeSender(cfg, qa, who) {
    return function (key, props) {
      if (qa) return Promise.resolve({ ok: false, reason: 'qa' });
      var identity = who.value;
      var metric = (cfg.metrics && cfg.metrics[key]) || key;
      var uid = (cfg.uids && cfg.uids[key]) || '';
      if (identity && identity.kind === 'klaviyo') {
        var k = root.klaviyo;
        if (!k || typeof k.track !== 'function') return Promise.resolve({ ok: false });
        return Promise.resolve(k.track(metric, Object.assign({ $event_id: uid }, props))).then(
          function (r) {
            return { ok: r !== false };
          },
          function () {
            return { ok: false };
          }
        );
      }
      var K = root.EBW && root.EBW.klaviyo;
      if (!identity || !identity.profile || !K || typeof K.event !== 'function') return Promise.resolve({ ok: false });
      return Promise.resolve(K.event(key, identity.profile, props)).then(
        function (r) {
          return { ok: !!(r && r.ok) };
        },
        function () {
          return { ok: false };
        }
      );
    };
  }

  function sentStore(local, key) {
    return {
      load: function () {
        return JSON.parse(sget(local, key) || '{}') || {};
      },
      save: function (map) {
        sset(local, key, JSON.stringify(map));
      },
    };
  }

  // Richtext del tema (HTML de Shopify) → nodos seguros: solo texto, <strong>/<b>/<em>/<i>/<br> y
  // enlaces internos, https o mailto. DOMParser no ejecuta nada; se reconstruye con createElement.
  function fillRich(box, html) {
    while (box.firstChild) box.removeChild(box.firstChild);
    var parsed = null;
    try {
      if (typeof root.DOMParser === 'function') parsed = new root.DOMParser().parseFromString(String(html), 'text/html');
    } catch (e) {
      parsed = null;
    }
    if (!parsed || !parsed.body) {
      fillParagraphs(box, splitLines(String(html).replace(/<\/p>|<br\s*\/?>/gi, '\n').replace(/<[^>]*>/g, '')));
      return;
    }
    var INLINE = { STRONG: 'strong', B: 'strong', EM: 'em', I: 'em' };
    function copy(from, to) {
      Array.prototype.forEach.call(from.childNodes, function (n) {
        if (n.nodeType === 3) to.appendChild(doc.createTextNode(n.nodeValue));
        else if (n.nodeType !== 1) return;
        else if (n.tagName === 'BR') to.appendChild(doc.createElement('br'));
        else if (INLINE[n.tagName]) copy(n, to.appendChild(doc.createElement(INLINE[n.tagName])));
        else if (n.tagName === 'A') {
          var href = n.getAttribute('href') || '';
          if (/^(\/(?!\/)|https:\/\/|mailto:)/i.test(href)) {
            var a = doc.createElement('a');
            a.setAttribute('href', href);
            copy(n, to.appendChild(a));
          } else copy(n, to);
        } else copy(n, to);
      });
    }
    var blocks = Array.prototype.filter.call(parsed.body.childNodes, function (n) {
      return n.nodeType === 1 || (n.nodeType === 3 && n.nodeValue.trim());
    });
    blocks.forEach(function (n) {
      var p = doc.createElement('p');
      if (n.nodeType === 3) p.appendChild(doc.createTextNode(n.nodeValue.trim()));
      else copy(n, p);
      if (p.textContent.trim()) box.appendChild(p);
    });
  }

  function mountRoom(el) {
    if (!el || el.__ebwRoom) return;
    var C = core();
    if (!C) {
      warn('core', 'eb-webinar-core.js no está cargado');
      return;
    }
    el.__ebwRoom = true;
    // En el editor de temas se ven todas las vistas para poder editar los textos: nada en vivo.
    if ((root.Shopify && root.Shopify.designMode) || el.getAttribute('data-room-view') === 'editor') return;

    var cfg = C.config() || {};
    var T = texts(el);
    var local = storageOf('localStorage');
    var session = storageOf('sessionStorage');
    var search = (root.location && root.location.search) || '';
    var sala = salaFrom(search);
    var qaClock = typeof C.isQaClock === 'function' && C.isQaClock();
    var qa = qaClock || sala === 'prueba';
    var startMs = C.parseISO(cfg.start);
    var codeUntil = C.parseISO(cfg.codeUntil);
    var replayUntil = C.parseISO(cfg.replayUntil);
    var grabEnvio = C.parseISO(el.getAttribute('data-grabacion-envio') || '');
    var tz = cfg.timezone || 'Europe/Madrid';
    var liveKey = sala === 'prueba' ? 'ebw_live_ms_prueba' : 'ebw_live_ms';
    var sentKey = sala === 'prueba' ? 'ebw_sent_prueba' : 'ebw_sent';

    var ui = {
      live: qs(el, '[data-ebw-room-live]'),
      counts: qsa(el, '[data-ebw-count]'),
      player: qs(el, '[data-ebw-player]'),
      poster: qs(el, '[data-ebw-poster]'),
      play: qs(el, '[data-ebw-play]'),
      waiting: qs(el, '[data-ebw-waiting]'),
      videoLink: qs(el, '[data-ebw-video-link]'),
      rail: qs(el, '[data-ebw-rail]'),
      phases: qsa(el, '[data-ebw-phase]'),
      phaseLive: qs(el, '[data-ebw-phase-live]'),
      tabs: qs(el, '[data-ebw-tabs]'),
      tabButtons: qsa(el, '[data-ebw-tab]'),
      panels: qsa(el, '[data-ebw-tabpanel]'),
      stage: qs(el, '.ebw-room__stage'),
      code: qs(el, '[data-ebw-code]'),
      codePill: qs(el, '[data-ebw-code-pill]'),
      codeValue: qs(el, '[data-ebw-code-value]'),
      codeCopy: qs(el, '[data-ebw-code-copy]'),
      codeCopied: qs(el, '[data-ebw-code-copied]'),
      codeSent: qs(el, '[data-ebw-code-sent]'),
      codeOther: qs(el, '[data-ebw-code-other]'),
      codeMini: qs(el, '[data-ebw-code-mini]'),
      codeFailed: qs(el, '[data-ebw-code-failed]'),
      honest: qs(el, '[data-ebw-honest]'),
      honestWorker: qs(el, '[data-ebw-honest-worker]'),
      honestTheme: qs(el, '[data-ebw-honest-theme]'),
      apuntate: qsa(el, '[data-ebw-apuntate]'),
      apuntateLinks: qsa(el, '[data-ebw-apuntate-link]'),
      grabPre: qsa(el, '[data-ebw-grab="pre"]'),
      grabPost: qsa(el, '[data-ebw-grab="post"]'),
      chat: qs(el, '[data-ebw-chat]'),
      chatList: qs(el, '[data-ebw-chat-list]'),
      chatScroll: qs(el, '[data-ebw-chat-scroll]'),
      chatEmpty: qs(el, '[data-ebw-chat-empty]'),
      chatJump: qs(el, '[data-ebw-chat-jump]'),
      chatStatus: qs(el, '[data-ebw-chat-status]'),
      chatAviso: qs(el, '[data-ebw-chat-aviso]'),
      chatAvisoText: qs(el, '[data-ebw-chat-aviso-text]'),
      chatAvisoMore: qs(el, '[data-ebw-chat-aviso-more]'),
      chatForm: qs(el, '[data-ebw-chat-form]'),
      chatInput: qs(el, '[data-ebw-chat-form] [name="text"]'),
      chatSend: qs(el, '[data-ebw-chat-form] [type="submit"]'),
      chatNameField: qs(el, '[data-ebw-chat-namefield]'),
      chatNameInput: qs(el, '[data-ebw-chat-namefield] [name="name"]'),
      chatWho: qs(el, '[data-ebw-chat-who]'),
      chatWhoName: qs(el, '[data-ebw-chat-whoname]'),
      chatRename: qs(el, '[data-ebw-chat-rename]'),
      chatError: qs(el, '[data-ebw-chat-error]'),
    };

    var phases = ui.phases.map(function (li) {
      return { el: li, inicio_min: num(li.getAttribute('data-start')), duracion_min: num(li.getAttribute('data-dur')) };
    });
    var secretLi = ui.phases.filter(function (li) {
      return li.hasAttribute('data-secret');
    })[0];

    // Hora de cada fase (en la zona del evento) junto al número.
    if (!isNaN(startMs) && typeof C.localTimeLabel === 'function') {
      phases.forEach(function (p) {
        var label = C.localTimeLabel(new Date(startMs + p.inicio_min * MIN).toISOString(), tz);
        setText(qs(p.el, '[data-ebw-phase-time]'), label ? label + ' h' : '');
      });
    }

    // Enlaces "apúntate" con la landing de la config (C1).
    var landing = (cfg.urls && cfg.urls.landing) || '';
    if (landing) {
      ui.apuntateLinks.forEach(function (a) {
        // Relativo: en la vista previa del tema DEV no se salta al dominio de la tienda.
        var qsPart = (a.getAttribute('href') || '').split('?')[1] || '';
        a.href = landing + (qsPart ? '?' + qsPart : '');
      });
    }

    // ---- estado de la persona ----------------------------------------------------------------
    var cid = sget(local, 'ebw_cid');
    if (!cid || !CID_RE.test(cid) || /^equipo/i.test(cid)) {
      cid = makeCid();
      sset(local, 'ebw_cid', cid);
    }
    var name = (sget(local, 'ebw_name') || '').trim().slice(0, 40);

    // Identidad: _kx ya; klaviyo.js al final del montaje (who.start). Si contesta tarde que sí,
    // sube a identificada salvo con el mini abierto o ya usado.
    var who = trackIdentity({
      search: search,
      session: session,
      onChange: function () {
        tick();
      },
      canUpgrade: function () {
        return !miniUsed && !(ui.codeMini && !ui.codeMini.hidden);
      },
    });

    var liveMs = qaClock ? 0 : Math.max(0, num(sget(session, liveKey)));
    var lastReal = Date.now();
    var lastSaved = 0;
    var store = sentStore(local, sentKey);
    var events = createEvents({
      send: makeSender(cfg, qa, who),
      load: store.load,
      save: store.save,
      onDone: function (key, ok, r) {
        if (!ok && r.reason !== 'qa') warn('evento ' + key + ' sin enviar' + (r.reason ? ' (' + r.reason + ')' : ''));
        tick();
      },
    });
    var miniUsed = false;
    var miniTouched = false; // ha empezado a escribir en el mini: no se le quita aunque el evento salga después
    var wantMini = false; // identificada que prefiere otro email ("¿Prefieres que te lo mande a otro email?")
    var failNoticed = false;

    // ---- render: cachés para tocar el DOM solo cuando algo cambia ------------------------------
    var model = initialModel();
    // armed: ya llegó el primer estado del Worker (lo que trae al entrar no se anima ni se anuncia:
    // ni la guinda, ni el código, ni la fase forzada).
    // inRoom: estuvo en la sala abierta o en directo (también si recarga en esta pestaña después).
    var cur = { state: null, view: null, phase: undefined, reveal: null, code: null, video: null, chatLine: null, tab: 'chat', tabbed: null, inRoom: liveMs > 0, codeShownOnce: false, revealArmed: false, codeArmed: false, phaseArmed: false };
    var lastSent = null; // último mensaje propio: para marcarlo y devolverlo al campo si el Worker lo rechaza
    var cooldownUntil = 0;
    var forcedSince = { index: -1, at: 0 };

    // Los avisos del mismo tic (estado, guinda, fase…) salen juntos y en orden.
    var announce = ui.live
      ? createAnnouncer({
          write: function (text) {
            ui.live.textContent = text;
          },
        })
      : function () {};

    function viewFor(state, t) {
      return state === 'ended' && !isNaN(replayUntil) && t >= replayUntil ? 'cerrado' : state;
    }

    function renderState(t) {
      var state = effectiveState(model, C.roomState(t, cfg), Date.now());
      var view = viewFor(state, t);
      if (state === 'doors' || state === 'live') cur.inRoom = true;
      el.classList.toggle('is-in-room', cur.inRoom && view !== 'cerrado');
      if (state !== cur.state) el.setAttribute('data-room-state', state);
      if (view !== cur.view) {
        var first = cur.view === null;
        el.setAttribute('data-room-view', view);
        cur.view = view;
        if (view === 'cerrado') {
          removePlayer();
          // Grabación retirada: ya no hay sala a la que conectarse.
          if (link) link.stop();
        }
        // El chat puede aparecer ahora: el aviso fijado se mide cuando se ve.
        setTimeout(measureAviso, 0);
        if (!first) {
          var key = { before: 'before_titulo', doors: 'doors_titulo', live: 'live_anuncio', ended: 'ended_titulo', cerrado: 'cerrado_titulo' }[view];
          announce(T[key]);
        }
      }
      cur.state = state;
      renderTabs();
      return state;
    }

    // ---- programa ------------------------------------------------------------------------------
    function phaseName(i) {
      var p = phases[i];
      if (!p) return '';
      var revealed = qs(p.el, '[data-ebw-secret-title]');
      if (p.el.hasAttribute('data-secret') && !revealed) return T.secreta_sello || '';
      var title = revealed || qs(p.el, '.ebw-program__title');
      return title ? title.textContent.replace(/\s+/g, ' ').trim() : '';
    }

    function renderPhase(t, state) {
      if (!phases.length || isNaN(startMs)) return;
      var localP = C.phaseAt(t, startMs, phases);
      var idx;
      var within = 0;
      if (state === 'before' || state === 'doors') idx = -1;
      else if (state === 'ended') idx = phases.length;
      else {
        idx = effectivePhase(model, localP.index, phases.length, Date.now());
        if (idx === localP.index) within = localP.within;
        else {
          // Fase forzada desde el panel: avanza desde que la vemos.
          if (forcedSince.index !== idx) forcedSince = { index: idx, at: t };
          var d = Math.max(1, phases[idx].duracion_min) * MIN;
          within = clamp01((t - forcedSince.at) / d);
        }
      }
      phases.forEach(function (p, i) {
        var done = i < idx;
        var active = i === idx;
        p.el.classList.toggle('is-done', done);
        p.el.classList.toggle('is-active', active);
        if (active) p.el.setAttribute('aria-current', 'step');
        else p.el.removeAttribute('aria-current');
        var fill = done ? 1 : active ? within : 0;
        p.el.style.setProperty('--ebw-fill', String(Math.round(fill * 1000) / 1000));
      });
      if (ui.rail) {
        var first = phases[0].inicio_min;
        var last = phases[phases.length - 1].inicio_min + phases[phases.length - 1].duracion_min;
        var pos = idx < 0 ? first : idx >= phases.length ? last : phases[idx].inicio_min + within * phases[idx].duracion_min;
        var overall = last > first ? clamp01((pos - first) / (last - first)) : 0;
        ui.rail.style.setProperty('--ebw-progress', String(Math.round(overall * 1000) / 1000));
      }
      // Hidratación: la primera pasada con el estado del Worker (WebSocket o GET /state). Quien
      // entra tarde con la fase forzada no oye "Ahora: …" al cargar.
      var hydrating = !!model.server && !cur.phaseArmed;
      if (model.server) cur.phaseArmed = true;
      if (idx !== cur.phase) {
        var prev = cur.phase;
        cur.phase = idx;
        if (phaseShouldAnnounce(prev, idx, phases.length, hydrating)) {
          announce((T.fase_anuncio || 'Ahora:') + ' ' + pad2(idx + 1) + ' · ' + phaseName(idx));
        }
      }
    }

    // ---- la guinda (el título llega solo del Worker) --------------------------------------------
    function renderReveal() {
      var r = model.server && model.server.revelado;
      var key = r && r.on ? r.titulo : '';
      var initial = !cur.revealArmed;
      cur.revealArmed = !!model.server;
      if (key === cur.reveal) return;
      cur.reveal = key;
      if (secretLi) {
        var box = qs(secretLi, '[data-ebw-secret]');
        var old = qs(secretLi, '[data-ebw-secret-title]');
        if (old) old.parentNode.removeChild(old);
        if (key && box) {
          var span = doc.createElement('span');
          span.className = 'ebw-redacted ebw-program__revealed';
          span.setAttribute('data-ebw-secret-title', '');
          span.textContent = key;
          box.insertBefore(span, box.firstChild);
          secretLi.removeAttribute('data-locked');
          secretLi.classList.add('is-revealed');
          // "Destachado": la barra se recoge y aparece el texto (eb-webinar.css, .is-lifted).
          if (initial || reducedMotion()) span.classList.add('is-lifted');
          else {
            void span.offsetWidth;
            setTimeout(function () {
              span.classList.add('is-lifted');
            }, 40);
          }
        } else {
          secretLi.setAttribute('data-locked', 'true');
          secretLi.classList.remove('is-revealed');
        }
      }
      if (key && !initial) {
        announce((T.revelado_anuncio || '') + ' ' + key);
        // Móvil: la guinda se desprecinta en la pestaña Programa; si mira el chat, punto de novedad.
        if (cur.tabbed && cur.tab !== 'programa') {
          var progTab = qs(el, '[data-ebw-tab="programa"]');
          if (progTab) progTab.classList.add('has-unread');
        }
      }
    }

    // Inicio de la fase secreta (para el aviso honesto sin Worker).
    var secretStartMs = (function () {
      var i = ui.phases.indexOf(secretLi);
      return i < 0 || isNaN(startMs) ? null : startMs + phases[i].inicio_min * MIN;
    })();

    function renderHonest(t) {
      if (!ui.honest) return;
      var r = model.server && model.server.revelado;
      var on = honestVisible({
        view: cur.view,
        revealed: !!(r && r.on),
        forced: forcedValid(model, Date.now()),
        t: t,
        secretStartMs: secretStartMs,
      });
      show(ui.honest, on);
      var workerText = r && r.on && r.texto ? splitLines(r.texto) : [];
      if (ui.honestWorker) {
        var joined = workerText.join('\n');
        if (ui.honestWorker.__ebwText !== joined) {
          ui.honestWorker.__ebwText = joined;
          fillParagraphs(ui.honestWorker, workerText);
        }
        show(ui.honestWorker, workerText.length > 0);
      }
      var useTheme = workerText.length === 0;
      // El de respaldo del tema va en base64 (no se lee en el código fuente antes del revelado):
      // se descodifica la primera vez que hace falta.
      if (on && useTheme && ui.honestTheme && !ui.honestTheme.__ebwFilled) {
        var b64 = ui.honestTheme.getAttribute('data-ebw-b64');
        if (b64) fillRich(ui.honestTheme, decodeB64Utf8(b64));
        ui.honestTheme.__ebwFilled = true;
      }
      show(ui.honestTheme, useTheme);
    }

    // ---- código de asistente ---------------------------------------------------------------------
    function renderCode(t) {
      if (!ui.code) return;
      var visible = codeVisible(model, t, codeUntil) && cur.view !== 'cerrado';
      var valor = visible ? model.server.codigo.valor : '';
      var quiet = !cur.codeArmed;
      cur.codeArmed = !!model.server;
      show(ui.code, visible);
      if (valor !== cur.code) {
        cur.code = valor;
        setText(ui.codeValue, valor);
        setText(ui.codeCopied, '');
        if (visible) {
          show(ui.codeCopy, true);
          if (!cur.codeShownOnce) {
            cur.codeShownOnce = true;
            if (quiet || reducedMotion()) ui.code.classList.add('is-open');
            else setTimeout(function () {
              ui.code.classList.add('is-open');
            }, 120);
            // Se revela ahora (no al entrar tarde): una señal junto al vídeo lleva hasta el sobre.
            if (!quiet) showPill(true);
          }
          if (!quiet) announce((T.codigo_titulo || '') + ': ' + valor);
          configureMini(valor);
        }
      }
      if (!visible) showPill(false);
      var identifiedNow = who.identified();
      var action = codeAction({
        visible: visible,
        identified: identifiedNow,
        liveMs: liveMs,
        sent: events.sent('codigo'),
        failed: events.failed('codigo'),
        qa: qa,
      });
      // Identificada y el evento ha fallado: mini con la explicación. Se sigue reintentando por
      // detrás (1 por minuto, 3 en total); si sale, el mini se va (salvo que ya escriba en él).
      var failedMini = action === 'mini' && identifiedNow === true;
      if (action === 'event' || (failedMini && !miniUsed)) sendCodigo(valor);
      var miniOn = action === 'mini' || ((miniUsed || wantMini || miniTouched) && visible);
      show(ui.codeMini, miniOn);
      show(ui.codeFailed, failedMini && !miniUsed);
      if (failedMini && !failNoticed) {
        failNoticed = true;
        announce(T.codigo_fallo_texto || '');
      }
      show(ui.codeSent, action === 'sent' && !miniUsed);
    }

    if (ui.codeMini) {
      ui.codeMini.addEventListener('input', function () {
        miniTouched = true;
      });
    }

    // ---- señal "tienes un regalo aquí abajo" -------------------------------------------------
    var pillObserver = null;

    function showPill(on) {
      if (!ui.codePill) return;
      show(ui.codePill, on);
      if (pillObserver) {
        pillObserver.disconnect();
        pillObserver = null;
      }
      if (!on || typeof root.IntersectionObserver !== 'function') return;
      // Con el sobre ya a la vista, sobra. En el móvil el vídeo fijo tapa la parte de arriba.
      var top = mq && mq.matches && ui.stage ? ui.stage.offsetHeight : 0;
      pillObserver = new root.IntersectionObserver(
        function (entries) {
          if (entries.some(function (e) {
            return e.isIntersecting;
          })) showPill(false);
        },
        { rootMargin: '-' + top + 'px 0px 0px 0px', threshold: 0.25 }
      );
      pillObserver.observe(ui.code);
    }

    if (ui.codePill) {
      ui.codePill.addEventListener('click', function (ev) {
        ev.preventDefault();
        showPill(false);
        try {
          ui.code.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'start' });
        } catch (e) {
          ui.code.scrollIntoView();
        }
        try {
          ui.code.focus({ preventScroll: true });
        } catch (e) {
          /* sin foco */
        }
      });
    }

    if (ui.codeOther) {
      ui.codeOther.addEventListener('click', function () {
        wantMini = !wantMini;
        ui.codeOther.setAttribute('aria-expanded', wantMini ? 'true' : 'false');
        tick();
        var input = wantMini && ui.codeMini && qs(ui.codeMini, '[name="email"]');
        if (input) input.focus();
      });
    }

    function configureMini(valor) {
      var form = ui.codeMini && qs(ui.codeMini, 'form[data-ebw-mini]');
      if (!form || !root.EBW || typeof root.EBW.mountMiniForm !== 'function') return;
      root.EBW.mountMiniForm(form, {
        metric: 'codigo',
        variante: 'directo',
        props: codigoProps(valor, function () {
          return liveMs;
        }),
        onDone: function () {
          var input = qs(form, '[name="email"]');
          var email = input ? String(input.value || '').trim().toLowerCase() : '';
          if (email) who.value = { kind: 'email', profile: { email: email } };
          miniUsed = true;
          events.mark('codigo');
          tick();
        },
      });
      // En la sala de prueba o con ?ebw_now= el mini se ve, pero no manda nada a Klaviyo.
      if (qa && !form.__ebwQaGuard) {
        form.__ebwQaGuard = true;
        form.addEventListener(
          'submit',
          function (ev) {
            ev.preventDefault();
            ev.stopImmediatePropagation();
            var msg = qs(form, '[data-ebw-form-msg]');
            setText(msg, T.qa_modo || 'Modo prueba: no se envía nada.');
          },
          true
        );
      }
    }

    // ---- Klaviyo (createEvents + makeSender) -------------------------------------------------------
    function sendCodigo(valor) {
      events.trySend('codigo', { codigo: valor, minutos: Math.floor(liveMs / MIN) });
    }

    function attend() {
      if (qa || !who.value) return;
      if (!shouldSendAttendance({ identified: true, liveMs: liveMs })) return;
      events.trySend('asistencia', { minutos: Math.floor(liveMs / MIN) });
    }

    function renderApuntate() {
      var on = who.value === null && (cur.view === 'before' || cur.view === 'ended');
      ui.apuntate.forEach(function (p) {
        show(p, on);
      });
    }

    function renderGrabacion(t) {
      var post = !isNaN(grabEnvio) && t >= grabEnvio;
      ui.grabPre.forEach(function (n) {
        show(n, !post);
      });
      ui.grabPost.forEach(function (n) {
        show(n, post);
      });
    }

    // ---- vídeo ------------------------------------------------------------------------------------
    var sectionVideo = cleanVideo({ proveedor: el.getAttribute('data-video-provider') || 'youtube', id: el.getAttribute('data-video-id') || '' });
    var cfCustomer = el.getAttribute('data-cf-customer') || '';
    var iframe = null;

    function currentVideo() {
      return (model.server && model.server.video) || sectionVideo;
    }

    function removePlayer() {
      if (iframe && iframe.parentNode) iframe.parentNode.removeChild(iframe);
      iframe = null;
      el.classList.remove('is-playing');
      show(ui.poster, true);
    }

    function renderVideo() {
      var v = currentVideo();
      var key = v ? v.proveedor + ':' + v.id : '';
      if (key === cur.video) return;
      cur.video = key;
      var watch = watchUrl(v);
      if (ui.videoLink) {
        if (watch) ui.videoLink.href = watch;
        show(ui.videoLink, !!watch);
      }
      show(ui.play, !!v);
      show(ui.waiting, !v);
      if (iframe) {
        if (v) iframe.src = embedUrl(v, { autoplay: true, customer: cfCustomer });
        else removePlayer();
      }
    }

    function startPlayer() {
      var v = currentVideo();
      if (!v || !ui.player) return;
      if (!iframe) {
        iframe = doc.createElement('iframe');
        iframe.className = 'ebw-room__iframe';
        iframe.title = (T.video_titulo || 'Vídeo del directo') + (cfg.titulo ? ': ' + cfg.titulo : '');
        // Pantalla completa con el atributo clásico (Safari y WebViews antiguos solo entienden ese),
        // como en el código de inserción de YouTube y de Cloudflare. Sin «fullscreen» en allow: con
        // los dos, Chrome avisa en la consola de que manda allow.
        iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
        ui.player.appendChild(iframe);
      }
      iframe.src = embedUrl(v, { autoplay: true, customer: cfCustomer });
      show(ui.poster, false);
      el.classList.add('is-playing');
      try {
        iframe.focus();
      } catch (e) {
        /* sin foco */
      }
    }

    if (ui.play) ui.play.addEventListener('click', startPlayer);

    // ---- contador ---------------------------------------------------------------------------------
    var countShown = null;
    var countAnim = null;

    function countLabel(n) {
      var label = T.contador_label || 'personas en la sala';
      return n === 1 ? label.replace(/^personas\b/, 'persona') : label;
    }

    function paintCount(n) {
      ui.counts.forEach(function (box) {
        setText(qs(box, '[data-ebw-count-num]'), String(n));
        setText(qs(box, '[data-ebw-count-label]'), countLabel(n));
      });
    }

    function renderCount() {
      var n = model.count;
      ui.counts.forEach(function (box) {
        show(box, n !== null);
      });
      if (n === null) {
        countShown = null;
        return;
      }
      var from = countShown;
      countShown = n;
      if (countAnim) root.cancelAnimationFrame(countAnim);
      countAnim = null;
      if (from === null || reducedMotion() || typeof root.requestAnimationFrame !== 'function') {
        paintCount(n);
        return;
      }
      // Sube o baja contando (easeOutCubic), sin saltos.
      var t0 = null;
      var step = function (ts) {
        if (t0 === null) t0 = ts;
        var k = clamp01((ts - t0) / 700);
        var e = 1 - Math.pow(1 - k, 3);
        paintCount(Math.round(from + (n - from) * e));
        countAnim = k < 1 ? root.requestAnimationFrame(step) : null;
      };
      countAnim = root.requestAnimationFrame(step);
    }

    // ---- pestañas (móvil) --------------------------------------------------------------------------
    var mq = root.matchMedia ? root.matchMedia('(max-width: 1023px)') : null;

    function renderTabs() {
      if (!ui.tabs) return;
      var chatView = cur.view === 'doors' || cur.view === 'live' || (cur.view === 'ended' && cur.inRoom);
      var tabbed = !!(chatView && mq && mq.matches);
      if (tabbed === cur.tabbed) return;
      cur.tabbed = tabbed;
      show(ui.tabs, tabbed);
      el.classList.toggle('is-tabbed', tabbed);
      ui.panels.forEach(function (panel) {
        var id = panel.getAttribute('data-ebw-tabpanel');
        var btn = qs(ui.tabs, '[data-ebw-tab="' + id + '"]');
        if (tabbed) {
          panel.setAttribute('role', 'tabpanel');
          if (btn) panel.setAttribute('aria-labelledby', btn.id);
          // El panel del programa no tiene nada enfocable: se enfoca él (patrón de pestañas WAI-ARIA).
          if (id === 'programa') panel.setAttribute('tabindex', '0');
        } else {
          panel.removeAttribute('role');
          panel.removeAttribute('aria-labelledby');
          if (id === 'programa') panel.removeAttribute('tabindex');
        }
      });
    }

    function selectTab(id, focus) {
      cur.tab = id;
      el.setAttribute('data-room-tab', id);
      ui.tabButtons.forEach(function (b) {
        var on = b.getAttribute('data-ebw-tab') === id;
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
        if (on && focus) b.focus();
        if (on) b.classList.remove('has-unread');
      });
      if (id === 'chat') {
        scrollChatToEnd();
        measureAviso();
      }
    }

    ui.tabButtons.forEach(function (b, i) {
      b.addEventListener('click', function () {
        selectTab(b.getAttribute('data-ebw-tab'), false);
      });
      b.addEventListener('keydown', function (ev) {
        var n = ui.tabButtons.length;
        var to = null;
        if (ev.key === 'ArrowRight') to = (i + 1) % n;
        else if (ev.key === 'ArrowLeft') to = (i - 1 + n) % n;
        else if (ev.key === 'Home') to = 0;
        else if (ev.key === 'End') to = n - 1;
        if (to === null) return;
        ev.preventDefault();
        selectTab(ui.tabButtons[to].getAttribute('data-ebw-tab'), true);
      });
    });
    if (mq) {
      var onMq = function () {
        renderTabs();
        measureAviso();
      };
      if (typeof mq.addEventListener === 'function') mq.addEventListener('change', onMq);
      else if (typeof mq.addListener === 'function') mq.addListener(onMq);
    }

    // ---- chat ---------------------------------------------------------------------------------------
    var link = null;
    var everOpen = false;
    var failedOnce = false;

    function norm(s) {
      return String(s || '').replace(/\s+/g, ' ').trim();
    }

    function msgNode(m) {
      var li = doc.createElement('li');
      li.className = 'ebw-chat__msg' + (m.team ? ' is-team' : '');
      li.setAttribute('data-id', m.id);
      if (lastSent && !m.team && norm(m.text) === norm(lastSent.text) && m.name === lastSent.name && Date.now() - lastSent.at < 15000) {
        li.classList.add('is-mine');
        lastSent = null;
      }
      var who = doc.createElement('span');
      who.className = 'ebw-chat__name';
      who.textContent = m.name;
      li.appendChild(who);
      var text = doc.createElement('span');
      text.className = 'ebw-chat__text';
      text.textContent = m.text;
      li.appendChild(text);
      return li;
    }

    function nearEnd() {
      var s = ui.chatScroll;
      return !s || s.scrollHeight - s.scrollTop - s.clientHeight < 96;
    }

    function scrollChatToEnd() {
      if (ui.chatScroll) ui.chatScroll.scrollTop = ui.chatScroll.scrollHeight;
      show(ui.chatJump, false);
    }

    // "Aún no hay mensajes. Estrénalo tú" solo con el chat conectado (si no, contradice al
    // "no disponible" de abajo).
    function renderEmpty() {
      show(ui.chatEmpty, !!ui.chatList && !ui.chatList.firstChild && model.link === 'open');
    }

    function renderAllMsgs() {
      if (!ui.chatList) return;
      while (ui.chatList.firstChild) ui.chatList.removeChild(ui.chatList.firstChild);
      var frag = doc.createDocumentFragment();
      model.msgs.forEach(function (m) {
        frag.appendChild(msgNode(m));
      });
      ui.chatList.appendChild(frag);
      renderEmpty();
      scrollChatToEnd();
    }

    function appendMsg(m) {
      if (!ui.chatList || !m) return;
      var stick = nearEnd();
      ui.chatList.appendChild(msgNode(m));
      while (ui.chatList.childNodes.length > MSG_MAX) ui.chatList.removeChild(ui.chatList.firstChild);
      renderEmpty();
      if (stick) scrollChatToEnd();
      else show(ui.chatJump, true);
      if (cur.tabbed && cur.tab !== 'chat') {
        var chatTab = qs(el, '[data-ebw-tab="chat"]');
        if (chatTab) chatTab.classList.add('has-unread');
      }
      if (m.team) announce((T.chat_equipo || 'Equipo') + ': ' + m.text);
    }

    function removeMsg(id) {
      if (!ui.chatList) return;
      qsa(ui.chatList, '[data-id]').forEach(function (li) {
        if (li.getAttribute('data-id') === id) li.parentNode.removeChild(li);
      });
      renderEmpty();
    }

    function chatMode() {
      return model.server ? model.server.chat : 'abierto';
    }

    // La línea de estado (encima del formulario) solo sale cuando no se puede escribir. El aviso
    // del modo lento va en la línea de ayuda del formulario, la misma de los errores: una sola línea.
    function renderChat() {
      var linkState = model.link;
      var open = linkState === 'open';
      if (open) everOpen = true;
      var line;
      if (model.banned) line = T.chat_err_banned || '';
      else if (!open && linkState === 'connecting' && !everOpen && !failedOnce) line = T.chat_conectando || '';
      else if (!open) line = T.chat_no_disponible || '';
      else if (chatMode() === 'cerrado') line = T.chat_err_closed || '';
      else line = '';
      if (line !== cur.chatLine) {
        cur.chatLine = line;
        setText(ui.chatStatus, line);
        show(ui.chatStatus, !!line);
      }
      var canWrite = open && !model.banned && chatMode() !== 'cerrado';
      // Si el formulario se oculta con el foco dentro (silenciada, chat cerrado, caída), el foco
      // pasa al registro del chat en vez de perderse.
      var active = doc.activeElement;
      var refocus = !canWrite && ui.chatForm && !ui.chatForm.hidden && active && ui.chatForm.contains(active);
      show(ui.chatForm, canWrite);
      if (refocus && ui.chatScroll) {
        try {
          ui.chatScroll.focus({ preventScroll: true });
        } catch (e) {
          /* sin foco */
        }
      }
      if (ui.chat) ui.chat.setAttribute('data-chat-link', open ? 'open' : linkState);
      renderAviso((model.server && model.server.aviso) || '');
      renderEmpty();
      renderHint();
      renderName();
    }

    // ---- aviso fijado: 3 líneas y "Leer entero" si no cabe --------------------------------------
    function setAvisoOpen(on) {
      if (!ui.chatAviso) return;
      ui.chatAviso.classList.toggle('is-expanded', on);
      if (ui.chatAvisoMore) {
        ui.chatAvisoMore.setAttribute('aria-expanded', on ? 'true' : 'false');
        setText(ui.chatAvisoMore, on ? T.aviso_menos || 'Ver menos' : T.aviso_mas || 'Leer entero');
      }
    }

    function measureAviso() {
      if (!ui.chatAvisoMore || !ui.chatAvisoText || !ui.chatAviso || ui.chatAviso.hidden) return;
      var open = ui.chatAviso.classList.contains('is-expanded');
      // Plegado y sin caber en 3 líneas (si el chat no se ve, mide 0: se vuelve a medir al verlo).
      var clamped = !open && ui.chatAvisoText.scrollHeight > ui.chatAvisoText.clientHeight + 2;
      show(ui.chatAvisoMore, open || clamped);
    }

    function renderAviso(text) {
      if (!ui.chatAviso) return;
      var box = ui.chatAvisoText || ui.chatAviso;
      if (box.textContent !== text) {
        box.textContent = text;
        setAvisoOpen(false);
      }
      show(ui.chatAviso, !!text);
      measureAviso();
    }

    if (ui.chatAvisoMore) {
      ui.chatAvisoMore.addEventListener('click', function () {
        setAvisoOpen(!ui.chatAviso.classList.contains('is-expanded'));
        measureAviso();
      });
    }
    var resizeQueued = false;
    root.addEventListener('resize', function () {
      if (resizeQueued) return;
      resizeQueued = true;
      setTimeout(function () {
        resizeQueued = false;
        measureAviso();
      }, 150);
    });

    // Sin nombre guardado se pide arriba del mensaje; con nombre, "Escribes como … · Cambiar".
    function renderName() {
      var editing = !!(ui.chatNameField && ui.chatNameField.__ebwEditing);
      show(ui.chatNameField, !name || editing);
      show(ui.chatWho, !!name && !editing);
      setText(ui.chatWhoName, name);
    }

    var chatErrText = '';

    // Línea de ayuda del formulario: el error si lo hay; si no, el aviso del modo lento.
    function renderHint() {
      var slow = model.link === 'open' && chatMode() === 'lento' ? T.chat_lento || '' : '';
      setText(ui.chatError, chatErrText || slow);
      if (ui.chatError) ui.chatError.classList.toggle('is-error', !!chatErrText);
    }

    function chatError(text) {
      chatErrText = text || '';
      renderHint();
    }

    function setName(n) {
      name = n.trim().slice(0, 40);
      sset(local, 'ebw_name', name);
      if (ui.chatNameField) ui.chatNameField.__ebwEditing = false;
      if (link && name) link.send({ t: 'hello', name: name });
      renderName();
    }

    function askName(focus) {
      if (!ui.chatNameField) return;
      ui.chatNameField.__ebwEditing = true;
      if (ui.chatNameInput && !ui.chatNameInput.value) ui.chatNameInput.value = name;
      renderName();
      if (focus && ui.chatNameInput) ui.chatNameInput.focus();
    }

    if (ui.chatRename) {
      ui.chatRename.addEventListener('click', function () {
        askName(true);
      });
    }
    if (ui.chatJump) ui.chatJump.addEventListener('click', scrollChatToEnd);
    if (ui.chatScroll) {
      ui.chatScroll.addEventListener('scroll', function () {
        if (nearEnd()) show(ui.chatJump, false);
      });
    }
    if (ui.chatInput) {
      ui.chatInput.addEventListener('input', function () {
        chatError('');
      });
    }

    if (ui.chatForm) {
      ui.chatForm.addEventListener('submit', function (ev) {
        ev.preventDefault();
        if (!link || model.link !== 'open') return chatError(T.chat_no_disponible);
        if (model.banned) return chatError(T.chat_err_banned);
        if (chatMode() === 'cerrado') return chatError(T.chat_err_closed);
        var text = norm(ui.chatInput && ui.chatInput.value);
        if (!text) {
          if (ui.chatInput) ui.chatInput.focus();
          return;
        }
        if (ui.chatNameField && !ui.chatNameField.hidden) {
          var typed = norm(ui.chatNameInput && ui.chatNameInput.value);
          if (!typed) {
            chatError(T.chat_nombre_label);
            if (ui.chatNameInput) ui.chatNameInput.focus();
            return;
          }
          setName(typed);
        }
        if (!name) {
          askName(true);
          return chatError(T.chat_nombre_label);
        }
        if (Date.now() < cooldownUntil) return chatError(T.chat_err_rate);
        if (!link.send({ t: 'msg', text: text, name: name })) return chatError(T.chat_no_disponible);
        lastSent = { text: text, name: name, at: Date.now() };
        cooldownUntil = Date.now() + (chatMode() === 'lento' ? 10000 : 4000);
        ui.chatInput.value = '';
        chatError('');
      });
    }

    function onServerError(e) {
      var key = CHAT_ERRORS[e.code];
      if (!key) return;
      if (lastSent && Date.now() - lastSent.at < 8000 && ui.chatInput && !ui.chatInput.value) ui.chatInput.value = lastSent.text;
      lastSent = null;
      if (e.code === 'banned') {
        // Silenciada (el modelo ya lo dice): sin formulario hasta la próxima conexión; lo explica la
        // línea de estado del chat, no la de ayuda del formulario (que así no se queda pegada).
        chatError('');
        renderChat();
        return;
      }
      chatError(T[key] || '');
      if (e.code === 'rate') cooldownUntil = Date.now() + (e.retryMs || 4000);
      else cooldownUntil = 0;
      if (e.code === 'name') {
        name = '';
        sdel(local, 'ebw_name');
        askName(true);
      }
    }

    // ---- conexión con el Worker ---------------------------------------------------------------------
    var live = cfg.live || {};
    link = createLink({
      url: wsUrl(live.ws, cid, sala),
      WebSocket: root.WebSocket,
      // Respaldo si la red bloquea los WebSockets: GET /state (CORS, x-ebw-server-now).
      httpUrl: stateUrl(live.http, sala),
      fetch: typeof root.fetch === 'function' ? root.fetch.bind(root) : null,
      AbortController: typeof root.AbortController === 'function' ? root.AbortController : null,
      onModel: function (m, msg) {
        model = m;
        switch (msg.t) {
          case 'hist':
            renderAllMsgs();
            // Sala reiniciada (historial vacío): fuera errores viejos; los silencios, también.
            if (!m.msgs.length) {
              chatError('');
              renderChat();
            }
            break;
          case 'msg':
            appendMsg(m.msgs[m.msgs.length - 1]);
            break;
          case 'del':
            removeMsg(msg.id);
            break;
          case 'count':
            renderCount();
            break;
          case 'err':
            onServerError(m.err);
            break;
          case 'link':
            if (msg.link === 'down' || msg.link === 'off') failedOnce = true;
            renderCount();
            renderChat();
            tick();
            break;
          default:
            // Primer estado de una conexión nueva: el error del formulario era de la anterior.
            if (msg.t === 'state' && msg.first === true) chatError('');
            renderChat();
            tick();
        }
      },
      onClock: function (offset) {
        if (Math.abs(offset) >= OFFSET_MIN_MS && typeof C.setServerOffset === 'function') C.setServerOffset(offset);
      },
      onOpen: function () {
        if (name) link.send({ t: 'hello', name: name });
      },
    });

    // ---- tic (cada segundo, desde core) -------------------------------------------------------------
    function tick() {
      var t = C.now();
      var real = Date.now();
      var state = renderState(t);
      if (!qaClock) {
        liveMs = accumulateLive(liveMs, lastReal, real, state);
        if (real - lastSaved > 5000) {
          lastSaved = real;
          sset(session, liveKey, String(Math.round(liveMs)));
        }
      }
      lastReal = real;
      // La guinda antes que la fase: el aviso "Ahora: 05 · …" ya lleva el título revelado.
      renderReveal();
      renderPhase(t, state);
      renderHonest(t);
      renderVideo();
      renderCode(t);
      renderApuntate();
      renderGrabacion(t);
      attend();
    }

    selectTab('chat', false);
    renderChat();
    renderCount();
    C.onTick(tick);
    // Desde que se retira la grabación ("cerrado") no se abre conexión con la sala.
    if (cur.view !== 'cerrado') link.start();

    // klaviyo.js: si conoce a la persona (cookie de un email anterior), cuenta como identificada.
    // Como mucho 8 s (watchIdentity); si no contesta, no identificada: ve el mini formulario y los
    // enlaces "apúntate". Si contesta tarde que sí, sube a identificada (salvo con el mini abierto).
    who.start();

    root.addEventListener('online', function () {
      link.wake();
    });
    root.addEventListener('pageshow', function (ev) {
      if (ev.persisted) link.wake();
    });
    if (doc) {
      doc.addEventListener('visibilitychange', function () {
        if (!doc.hidden) link.wake();
      });
    }

    // Copiar el código: portapapeles moderno; si no, execCommand (como core); si tampoco, se
    // selecciona el código y se dice que no se ha podido.
    function legacyCopy(text) {
      var ok = false;
      var ta = null;
      try {
        ta = doc.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.className = 'ebw-visually-hidden';
        doc.body.appendChild(ta);
        ta.select();
        ok = doc.execCommand('copy') === true;
      } catch (e) {
        ok = false;
      }
      if (ta && ta.parentNode) ta.parentNode.removeChild(ta);
      return ok;
    }

    function selectCode() {
      try {
        var range = doc.createRange();
        range.selectNodeContents(ui.codeValue);
        var sel = root.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
      } catch (e) {
        /* sin selección */
      }
    }

    if (ui.codeCopy) {
      ui.codeCopy.addEventListener('click', function () {
        var value = cur.code || '';
        if (!value) return;
        var done = function (ok) {
          setText(ui.codeCopied, ok ? T.codigo_copiado || 'Copiado.' : T.codigo_no_copiado || 'No he podido copiarlo.');
          if (!ok && ui.codeValue) selectCode();
        };
        var fallback = function () {
          done(legacyCopy(value));
        };
        try {
          if (root.navigator && root.navigator.clipboard && root.isSecureContext) {
            root.navigator.clipboard.writeText(value).then(function () {
              done(true);
            }, fallback);
            return;
          }
        } catch (e) {
          /* sin portapapeles moderno */
        }
        fallback();
      });
    }

    el.__ebwRoomApi = { link: link, model: function () { return model; }, tick: tick };
  }

  /* ------------------------------------------------------------------ */
  /* DOM: la grabación (contrato del marcado en la cabecera, parte 3)     */
  /* ------------------------------------------------------------------ */

  function mountReplay(el) {
    if (!el || el.__ebwReplay) return;
    var C = core();
    if (!C) {
      warn('core', 'eb-webinar-core.js no está cargado');
      return;
    }
    el.__ebwReplay = true;
    // En el editor de temas se ve todo para editar los textos: nada en vivo.
    if ((root.Shopify && root.Shopify.designMode) || el.getAttribute('data-replay-view') === 'editor') return;

    var cfg = C.config() || {};
    var T = texts(el, 'script[data-ebw-replay-text]');
    var local = storageOf('localStorage');
    var session = storageOf('sessionStorage');
    var search = (root.location && root.location.search) || '';
    var qa = typeof C.isQaClock === 'function' && C.isQaClock();
    var replayUntil = C.parseISO(cfg.replayUntil);
    var video = cleanVideo({ proveedor: el.getAttribute('data-video-provider') || 'youtube', id: el.getAttribute('data-video-id') || '' });
    var customer = el.getAttribute('data-cf-customer') || '';
    // La vista de partida la decide el servidor: si Liquid ha pintado la grabación (hay algo en
    // «Id del vídeo»), no se pasa a la espera aunque el id no valga aquí (un enlace mal pegado): la
    // espera no está en ese HTML y la página se quedaría en blanco. Se queda la grabación sin play
    // ni enlace al vídeo y con [data-ebw-video-missing].
    var published = !!video || el.getAttribute('data-replay-view') === 'grabacion';

    var ui = {
      player: qs(el, '[data-ebw-player]'),
      poster: qs(el, '[data-ebw-poster]'),
      play: qs(el, '[data-ebw-play]'),
      missing: qs(el, '[data-ebw-video-missing]'),
      videoLink: qs(el, '[data-ebw-video-link]'),
      chapters: qsa(el, '[data-ebw-chapter]'),
      live: qs(el, '[data-ebw-replay-live]'),
    };
    var announce = ui.live
      ? createAnnouncer({
          write: function (text) {
            ui.live.textContent = text;
          },
        })
      : function () {};

    var firstChapter = ui.chapters.length ? parseStart(ui.chapters[0].getAttribute('data-start')) : 0;
    var defaultStart = el.hasAttribute('data-video-start') ? parseStart(el.getAttribute('data-video-start')) : firstChapter;

    // Hora de cada capítulo si la sección no la ha escrito.
    ui.chapters.forEach(function (ch) {
      var time = qs(ch, '[data-ebw-chapter-time]');
      if (time && !time.textContent.trim()) time.textContent = formatClock(ch.getAttribute('data-start'));
    });

    var who = trackIdentity({ search: search, session: session, onChange: function () {
      tick();
    } });
    var store = sentStore(local, 'ebw_sent');
    var events = createEvents({
      send: makeSender(cfg, qa, who),
      load: store.load,
      save: store.save,
      onDone: function (key, ok, r) {
        if (!ok && r.reason !== 'qa') warn('evento ' + key + ' sin enviar' + (r.reason ? ' (' + r.reason + ')' : ''));
      },
    });

    var view = null;
    var iframe = null;
    var clicked = false;
    var startedAt = defaultStart;
    var visibleMs = 0;
    var lastReal = Date.now();
    var inView = true;
    var io = null;

    function setVideoLink(start) {
      var watch = watchUrl(video, start);
      if (!ui.videoLink) return;
      if (watch) ui.videoLink.href = watch;
      show(ui.videoLink, !!watch);
    }

    function removePlayer() {
      if (io) {
        io.disconnect();
        io = null;
      }
      if (iframe && iframe.parentNode) iframe.parentNode.removeChild(iframe);
      iframe = null;
      el.classList.remove('is-playing');
      show(ui.poster, true);
    }

    function startPlayer(start, autoplay) {
      if (!video || !ui.player || view !== 'grabacion') return false;
      if (!iframe) {
        iframe = doc.createElement('iframe');
        iframe.className = 'ebw-room__iframe';
        iframe.title = (T.video_titulo || 'Grabación del directo') + (cfg.titulo ? ': ' + cfg.titulo : '');
        iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture'); // + allowfullscreen (ver la sala)
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
        ui.player.appendChild(iframe);
        if (typeof root.IntersectionObserver === 'function') {
          io = new root.IntersectionObserver(
            function (entries) {
              inView = entries.some(function (e) {
                return e.isIntersecting;
              });
            },
            { threshold: 0.5 }
          );
          io.observe(ui.player);
        }
      }
      startedAt = parseStart(start);
      iframe.src = embedUrl(video, { autoplay: autoplay, start: startedAt, customer: customer });
      show(ui.poster, false);
      el.classList.add('is-playing');
      setVideoLink(startedAt);
      return true;
    }

    function markChapter(active) {
      ui.chapters.forEach(function (ch) {
        var on = ch === active;
        ch.classList.toggle('is-active', on);
        if (on) ch.setAttribute('aria-current', 'true');
        else ch.removeAttribute('aria-current');
      });
    }

    function playerInViewport() {
      if (!ui.player || typeof ui.player.getBoundingClientRect !== 'function') return true;
      var r = ui.player.getBoundingClientRect();
      var h = root.innerHeight || (doc.documentElement && doc.documentElement.clientHeight) || 0;
      return r.top >= 0 && r.bottom <= h;
    }

    if (ui.play) {
      ui.play.addEventListener('click', function () {
        if (!startPlayer(defaultStart, true)) return;
        clicked = true;
        try {
          iframe.focus();
        } catch (e) {
          /* sin foco */
        }
        tick();
      });
    }

    ui.chapters.forEach(function (ch) {
      ch.addEventListener('click', function (ev) {
        if (view !== 'grabacion' || !video) return; // sin vídeo: el enlace (si lo es) hace lo suyo
        // Cmd/Ctrl/Mayús/Alt + clic (o botón central) en un enlace: lo abre el navegador donde se le
        // pide (otra pestaña o ventana) y el vídeo de aquí no se toca.
        if (ch.hasAttribute('href') && (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey || ev.button > 0)) return;
        ev.preventDefault();
        if (!startPlayer(ch.getAttribute('data-start'), true)) return;
        clicked = true;
        markChapter(ch);
        // El foco se queda en el capítulo; el vídeo, a la vista (en el móvil ya está fijo arriba).
        if (!playerInViewport()) {
          try {
            ui.player.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'nearest' });
          } catch (e) {
            ui.player.scrollIntoView();
          }
        }
        var title = qs(ch, '[data-ebw-chapter-title]') || ch;
        announce((T.capitulo_anuncio || 'Vídeo desde') + ' ' + formatClock(startedAt) + ' · ' + title.textContent.replace(/\s+/g, ' ').trim());
        tick();
      });
    });

    function tick() {
      var t = C.now();
      var real = Date.now();
      var next = replayView(t, replayUntil, published);
      if (next !== view) {
        var first = view === null;
        view = next;
        el.setAttribute('data-replay-view', view);
        if (view === 'cerrado') {
          // Si se estaba usando el reproductor, el foco no se pierde con el iframe: va al cierre.
          var focusInPlayer = !first && !!iframe && !!doc && doc.activeElement === iframe;
          removePlayer();
          if (!first) announce(T.cerrado_anuncio || 'La grabación ya no está disponible.');
          var heading = focusInPlayer ? qs(el, '[data-ebw-replay-focus]') : null;
          if (heading) {
            try {
              heading.focus();
            } catch (e) {
              /* sin foco */
            }
          }
        } else if (view === 'grabacion') {
          show(ui.play, !!video);
          show(ui.missing, !video);
          setVideoLink(defaultStart);
          // Sin póster: el iframe va desde el principio (sin autoplay) y cuenta lo que se ve.
          if (!ui.play && !iframe) startPlayer(defaultStart, false);
        }
      }
      var watching = !!iframe && view === 'grabacion' && !(doc && doc.hidden) && inView;
      visibleMs = accumulateLive(visibleMs, lastReal, real, watching ? 'live' : '');
      lastReal = real;
      var ok = replayShouldSend({
        identified: who.identified(),
        clicked: clicked,
        visibleMs: visibleMs,
        sent: events.sent('grabacion'),
        qa: qa,
      });
      if (ok) events.trySend('grabacion', { segundo: startedAt, via: clicked ? 'clic' : 'visible' });
    }

    C.onTick(tick);
    who.start();
    el.__ebwReplayApi = { tick: tick };
  }

  function mountAll(scope) {
    var base = scope && scope.querySelectorAll ? scope : doc;
    if (!base) return;
    [
      ['[data-ebw-room]', mountRoom],
      ['[data-ebw-replay]', mountReplay],
    ].forEach(function (pair) {
      var list = Array.prototype.slice.call(base.querySelectorAll(pair[0]));
      if (base.matches && base.matches(pair[0])) list.unshift(base);
      list.forEach(function (el) {
        try {
          pair[1](el);
        } catch (e) {
          warn('mount', e);
        }
      });
    });
  }

  function boot() {
    var C = core();
    var run = function () {
      mountAll(doc);
    };
    if (C && typeof C.onReady === 'function') C.onReady(run);
    else if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', run);
    else run();
    doc.addEventListener('shopify:section:load', function (ev) {
      mountAll(ev.target);
    });
  }

  return {
    version: '1.2.0',
    // puras
    backoff: backoff,
    stableDropDelay: stableDropDelay,
    clockOffset: clockOffset,
    shouldSendAttendance: shouldSendAttendance,
    accumulateLive: accumulateLive,
    initialModel: initialModel,
    reduce: reduce,
    forcedValid: forcedValid,
    effectiveState: effectiveState,
    effectivePhase: effectivePhase,
    codeVisible: codeVisible,
    codeAction: codeAction,
    honestVisible: honestVisible,
    phaseShouldAnnounce: phaseShouldAnnounce,
    embedUrl: embedUrl,
    watchUrl: watchUrl,
    wsUrl: wsUrl,
    stateUrl: stateUrl,
    salaFrom: salaFrom,
    makeCid: makeCid,
    parseMessage: parseMessage,
    splitLines: splitLines,
    withoutKx: withoutKx,
    codigoProps: codigoProps,
    parseStart: parseStart,
    formatClock: formatClock,
    replayView: replayView,
    replayShouldSend: replayShouldSend,
    decodeB64Utf8: decodeB64Utf8,
    createAnnouncer: createAnnouncer,
    createEvents: createEvents,
    watchIdentity: watchIdentity,
    createLink: createLink,
    // DOM
    mountRoom: mountRoom,
    mountReplay: mountReplay,
    mountAll: mountAll,
    _boot: boot,
  };
});
